import { SVGProps } from "react";

export const HamburguerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
    >
      <path
        id="Union_83"
        data-name="Union 83"
        d="M1.058,16a1.059,1.059,0,0,1,0-2.118H17.941a1.059,1.059,0,0,1,0,2.118Zm0-6.942a1.059,1.059,0,0,1,0-2.118H17.941a1.059,1.059,0,0,1,0,2.118Zm0-6.941A1.059,1.059,0,0,1,1.058,0H17.941a1.059,1.059,0,0,1,0,2.118Z"
        fill="#333"
      />
    </svg>
  );
};

export const ChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.296"
      height="31.298"
      viewBox="0 0 31.296 31.298"
    >
      <g id="chataa" transform="translate(0.281 0.3)">
        <g id="Group_2" data-name="Group 2" transform="translate(-0.281 -0.3)">
          <path
            id="Path_3"
            data-name="Path 3"
            d="M26.071,4.474A15.264,15.264,0,0,0,3.522,25a5.841,5.841,0,0,1-2.447,2.711,1.432,1.432,0,0,0,.413,2.7A7.889,7.889,0,0,0,2.7,30.5a9.114,9.114,0,0,0,5.371-1.782,15.262,15.262,0,0,0,18-24.247ZM24.838,24.828a13.521,13.521,0,0,1-16.41,2.1.868.868,0,0,0-1.059.136.287.287,0,0,0-.071.052,7.453,7.453,0,0,1-4.6,1.64H2.689A8.547,8.547,0,0,0,5.31,25.28a.892.892,0,0,0,.045-.562.906.906,0,0,0-.213-.491,13.522,13.522,0,1,1,19.7.6Z"
            transform="translate(0.363 0.382)"
            fill="#fff"
          />
          <path
            id="Path_3_-_Outline"
            data-name="Path 3 - Outline"
            d="M15.359-.3a15.646,15.646,0,0,1,11.07,26.713A15.643,15.643,0,0,1,8.176,29.249a9.489,9.489,0,0,1-5.4,1.717,8.265,8.265,0,0,1-1.266-.095,1.814,1.814,0,0,1-.524-3.418A5.327,5.327,0,0,0,3.15,25.132,15.648,15.648,0,0,1,15.359-.3Zm-.006,30.535A14.879,14.879,0,1,0,3.9,24.84l.159.191-.111.223a6.265,6.265,0,0,1-2.62,2.884,1.041,1.041,0,0,0-.572,1.1,1.052,1.052,0,0,0,.876.883,7.5,7.5,0,0,0,1.148.086,8.757,8.757,0,0,0,5.148-1.71l.194-.14.21.113A14.861,14.861,0,0,0,15.352,30.235Zm0-28.784A13.9,13.9,0,0,1,25.189,25.18,13.9,13.9,0,0,1,8.316,27.343a.485.485,0,0,0-.6.076l-.044.044-.044.025-.019.015a7.836,7.836,0,0,1-4.837,1.72H1.6l.946-.69a8.216,8.216,0,0,0,2.495-3.32.507.507,0,0,0,.026-.32l-.006-.025,0-.026a.526.526,0,0,0-.123-.283A13.9,13.9,0,0,1,15.355,1.451Zm-.008,27.043a13.142,13.142,0,0,0,9.3-22.435,13.14,13.14,0,0,0-19.134,18,1.3,1.3,0,0,1,.3.676,1.274,1.274,0,0,1-.069.775l0,.007a9.865,9.865,0,0,1-1.85,2.85,7.274,7.274,0,0,0,3.241-1.453.673.673,0,0,1,.087-.068A1.248,1.248,0,0,1,8.7,26.686,13.124,13.124,0,0,0,15.347,28.494Z"
            transform="translate(0.281 0.3)"
            fill="#fff"
          />
          <circle
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="1.072"
            cy="1.072"
            r="1.072"
            transform="translate(14.569 14.577)"
            fill="#fff"
          />
          <path
            id="Ellipse_1_-_Outline"
            data-name="Ellipse 1 - Outline"
            d="M1.153-.3A1.453,1.453,0,1,1-.3,1.153,1.455,1.455,0,0,1,1.153-.3Zm0,2.143a.69.69,0,1,0-.69-.69A.691.691,0,0,0,1.153,1.843Z"
            transform="translate(14.487 14.496)"
            fill="#fff"
          />
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="1.072"
            cy="1.072"
            r="1.072"
            transform="translate(20.095 14.577)"
            fill="#fff"
          />
          <path
            id="Ellipse_2_-_Outline"
            data-name="Ellipse 2 - Outline"
            d="M1.153-.3A1.453,1.453,0,1,1-.3,1.153,1.455,1.455,0,0,1,1.153-.3Zm0,2.143a.69.69,0,1,0-.69-.69A.691.691,0,0,0,1.153,1.843Z"
            transform="translate(20.013 14.496)"
            fill="#fff"
          />
          <circle
            id="Ellipse_3"
            data-name="Ellipse 3"
            cx="1.072"
            cy="1.072"
            r="1.072"
            transform="translate(9.043 14.577)"
            fill="#fff"
          />
          <path
            id="Ellipse_3_-_Outline"
            data-name="Ellipse 3 - Outline"
            d="M1.153-.3A1.453,1.453,0,1,1-.3,1.153,1.455,1.455,0,0,1,1.153-.3Zm0,2.143a.69.69,0,1,0-.69-.69A.691.691,0,0,0,1.153,1.843Z"
            transform="translate(8.961 14.496)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.553"
    height="15.473"
    viewBox="0 0 13.553 15.473"
  >
    <g id="back-arw" transform="translate(34.734 0) rotate(90)">
      <g id="Group_71" data-name="Group 71" transform="translate(0 21.181)">
        <g id="Group_70" data-name="Group 70" transform="translate(0 0)">
          <path
            id="Path_40"
            data-name="Path 40"
            d="M7.76,22.6,6.445,21.181.6,26.6a1.847,1.847,0,0,0,.006,2.734l5.83,5.4,1.314-1.418L1.975,27.964Z"
            transform="translate(0 -21.181)"
            fill="#ee312f"
          />
        </g>
      </g>
      <g id="Group_73" data-name="Group 73" transform="translate(1.938 26.989)">
        <g id="Group_72" data-name="Group 72">
          <rect
            id="Rectangle_4480"
            data-name="Rectangle 4480"
            width="13.535"
            height="1.934"
            fill="#ee312f"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.631"
    height="6.376"
    viewBox="0 0 16.631 6.376"
  >
    <path
      id="drop-down-arrow"
      d="M8.2,6.335.585,2.233A1.3,1.3,0,0,1,.117.593,1.3,1.3,0,0,1,1.757.124L8.2,3.64,15,.124a1.034,1.034,0,0,1,1.523.469,1.119,1.119,0,0,1-.469,1.523Z"
      transform="translate(16.635 6.335) rotate(180)"
      fill="#898989"
    />
  </svg>
);

export const ThankYouIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79"
      height="78.999"
      viewBox="0 0 79 78.999"
    >
      <path
        id="Subtraction_23"
        data-name="Subtraction 23"
        d="M-21143.5,12050a39.252,39.252,0,0,1-15.373-3.1,39.383,39.383,0,0,1-12.557-8.465,39.362,39.362,0,0,1-8.465-12.557,39.207,39.207,0,0,1-3.105-15.373,39.221,39.221,0,0,1,3.105-15.376,39.362,39.362,0,0,1,8.465-12.557,39.386,39.386,0,0,1,12.557-8.464,39.244,39.244,0,0,1,15.373-3.1,39.244,39.244,0,0,1,15.373,3.1,39.386,39.386,0,0,1,12.557,8.464,39.362,39.362,0,0,1,8.465,12.557,39.221,39.221,0,0,1,3.105,15.376,39.207,39.207,0,0,1-3.105,15.373,39.362,39.362,0,0,1-8.465,12.557,39.383,39.383,0,0,1-12.557,8.465A39.252,39.252,0,0,1-21143.5,12050Zm-14.51-40.807a1.965,1.965,0,0,0-1.242.436,1.972,1.972,0,0,0-.742,1.337,1.982,1.982,0,0,0,.422,1.47l10.809,13.572a2,2,0,0,0,1.563.755.694.694,0,0,0,.1,0,2,2,0,0,0,1.584-.92l18.209-28.526a1.978,1.978,0,0,0,.268-1.512,1.967,1.967,0,0,0-.875-1.248,2,2,0,0,0-1.072-.313,2,2,0,0,0-1.691.92l-16.7,26.166-9.064-11.376A1.987,1.987,0,0,0-21158.01,12009.193Z"
        transform="translate(21183 -11971.001)"
        fill="#2cbe69"
      />
    </svg>
  );
};

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
  >
    <path
      id="Polygon_9"
      data-name="Polygon 9"
      d="M5.5,0,6.71,4.29,11,5.5,6.71,6.71,5.5,11,4.29,6.71,0,5.5,4.29,4.29Z"
      fill="#333"
    />
  </svg>
);

export const IconBadge = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1286 1.09126C17.0605 0.986549 16.9674 0.900492 16.8576 0.840899C16.7479 0.781307 16.625 0.750066 16.5001 0.750011H12.0001C11.8607 0.749946 11.7241 0.788719 11.6055 0.861978C11.487 0.935238 11.3911 1.04009 11.3288 1.16476L9.00009 5.82301L6.67509 1.16476C6.61251 1.03951 6.51612 0.934287 6.39683 0.860988C6.27753 0.78769 6.14011 0.749247 6.00009 0.750011H1.5001C1.37514 0.749995 1.25216 0.781201 1.14233 0.840792C1.0325 0.900384 0.939293 0.986473 0.871188 1.09124C0.803083 1.196 0.762233 1.31613 0.75235 1.44069C0.742467 1.56526 0.763863 1.69032 0.814595 1.80451L4.30435 9.66676C3.94042 10.3907 3.75063 11.1897 3.7501 12C3.7501 13.3924 4.30322 14.7278 5.28778 15.7123C6.27235 16.6969 7.60771 17.25 9.00009 17.25C10.3925 17.25 11.7278 16.6969 12.7124 15.7123C13.697 14.7278 14.2501 13.3924 14.2501 12C14.2496 11.1897 14.0598 10.3907 13.6958 9.66676L17.1856 1.80451C17.2363 1.69029 17.2576 1.56521 17.2476 1.44065C17.2377 1.31609 17.1968 1.19599 17.1286 1.09126ZM2.6536 2.25001H5.53659L7.85184 6.88051C6.89733 7.09573 6.02208 7.57376 5.3251 8.26051L2.6536 2.25001ZM9.00009 15.75C8.25841 15.75 7.53339 15.5301 6.91671 15.118C6.30002 14.706 5.81938 14.1203 5.53555 13.4351C5.25172 12.7499 5.17746 11.9959 5.32215 11.2684C5.46685 10.541 5.824 9.87281 6.34844 9.34836C6.87289 8.82391 7.54108 8.46676 8.26851 8.32207C8.99593 8.17737 9.74993 8.25163 10.4352 8.53546C11.1204 8.81929 11.7061 9.29994 12.1181 9.91662C12.5302 10.5333 12.7501 11.2583 12.7501 12C12.7489 12.9942 12.3534 13.9473 11.6504 14.6503C10.9474 15.3534 9.99429 15.7488 9.00009 15.75ZM12.6788 8.26051C11.9808 7.57315 11.1042 7.09508 10.1483 6.88051L12.4636 2.25001H15.3466L12.6788 8.26051ZM11.2501 11.469L9.99984 12.5003L10.3906 14.25L9.00009 13.2503L7.60959 14.25L8.00034 12.5003L6.75009 11.469L8.25009 11.25L9.00009 9.75001L9.75009 11.25L11.2501 11.469Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconRate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.002"
      height="13.36"
      viewBox="0 0 14.002 13.36"
    >
      <path
        id="Subtraction_13"
        data-name="Subtraction 13"
        d="M-15945,11984.361h0V11974a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v5a3.005,3.005,0,0,1-3,3h-7.659l-3.338,2.356Zm8.669-12.064h0l-.5.3a.557.557,0,0,0-.089.063.277.277,0,0,0-.056.093.3.3,0,0,0-.012.12.481.481,0,0,0,.056.164,7.513,7.513,0,0,1,.645,1.681,7.785,7.785,0,0,1,.22,1.824,7.8,7.8,0,0,1-.22,1.825,7.6,7.6,0,0,1-.645,1.681.42.42,0,0,0-.056.16.314.314,0,0,0,.012.124.394.394,0,0,0,.056.088.276.276,0,0,0,.089.063l.5.3a8.633,8.633,0,0,0,.563-1.032,7.839,7.839,0,0,0,.385-1.045,6.825,6.825,0,0,0,.216-1.064,9.77,9.77,0,0,0,.068-1.1,9.6,9.6,0,0,0-.068-1.1,7.294,7.294,0,0,0-.216-1.068,7.419,7.419,0,0,0-.385-1.04,7.552,7.552,0,0,0-.563-1.028Zm-2.669,5.066a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-15939,11977.363Zm0-3a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-15939,11974.362Z"
        transform="translate(15945.001 -11971.001)"
        fill="#ee312f"
      />
    </svg>
  );
};

export const IconCertificate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.002"
      height="13.998"
      viewBox="0 0 14.002 13.998"
    >
      <path
        id="Subtraction_16"
        data-name="Subtraction 16"
        d="M-15938,11985a6.966,6.966,0,0,1-4.953-2.05A6.946,6.946,0,0,1-15945,11978a6.952,6.952,0,0,1,2.049-4.952A6.965,6.965,0,0,1-15938,11971a6.964,6.964,0,0,1,4.951,2.049A6.952,6.952,0,0,1-15931,11978a6.946,6.946,0,0,1-2.049,4.947A6.961,6.961,0,0,1-15938,11985Zm-2.74-7.707h0l-1,.895,2.58,2.669a.714.714,0,0,0,.5.209.066.066,0,0,0,.02,0h.021a.682.682,0,0,0,.51-.267l3.848-5.09-1.109-.771-3.094,4.1-.262.344-2.012-2.084Z"
        transform="translate(15945 -11971.002)"
        fill="#2cbe69"
      />
    </svg>
  );
};

export const IconTag = () => {
  return (
    <svg
      width="62"
      height="61"
      viewBox="0 0 62 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.90625 57.8961V19.3961C0.906281 18.9996 0.992067 18.6077 1.15773 18.2475C1.32339 17.8872 1.565 17.567 1.866 17.3089L21.116 0.808863C21.6141 0.382807 22.248 0.148682 22.9035 0.148682C23.559 0.148682 24.1929 0.382807 24.691 0.808863L43.941 17.3089C44.243 17.5665 44.4857 17.8864 44.6523 18.2467C44.8189 18.607 44.9055 18.9992 44.9062 19.3961V38.6461C44.9062 39.3755 44.6165 40.0749 44.1008 40.5907C43.5851 41.1064 42.8856 41.3961 42.1562 41.3961C41.4269 41.3961 40.7274 41.1064 40.2117 40.5907C39.696 40.0749 39.4062 39.3755 39.4062 38.6461V20.6611L22.9062 6.51786L6.40625 20.6611V55.1461H39.4062C40.1356 55.1461 40.8351 55.4358 41.3508 55.9516C41.8665 56.4673 42.1562 57.1668 42.1562 57.8961C42.1562 58.6255 41.8665 59.3249 41.3508 59.8407C40.8351 60.3564 40.1356 60.6461 39.4062 60.6461H3.65625C2.9269 60.6461 2.22743 60.3564 1.71171 59.8407C1.19598 59.3249 0.90625 58.6255 0.90625 57.8961ZM17.4062 22.1461C17.4062 23.2339 17.7288 24.2973 18.3332 25.2017C18.9375 26.1062 19.7965 26.8112 20.8015 27.2274C21.8065 27.6437 22.9124 27.7526 23.9792 27.5404C25.0461 27.3282 26.0261 26.8044 26.7953 26.0352C27.5645 25.266 28.0884 24.286 28.3006 23.2191C28.5128 22.1522 28.4039 21.0463 27.9876 20.0414C27.5713 19.0364 26.8664 18.1774 25.9619 17.573C25.0574 16.9687 23.994 16.6461 22.9062 16.6461C21.4476 16.6461 20.0486 17.2256 19.0172 18.257C17.9857 19.2885 17.4062 20.6874 17.4062 22.1461ZM61.4062 49.6461C61.4062 48.9168 61.1165 48.2173 60.6008 47.7016C60.0851 47.1858 59.3856 46.8961 58.6562 46.8961H53.1562V41.3961C53.1562 40.6668 52.8665 39.9673 52.3508 39.4516C51.8351 38.9358 51.1356 38.6461 50.4062 38.6461C49.6769 38.6461 48.9774 38.9358 48.4617 39.4516C47.946 39.9673 47.6562 40.6668 47.6562 41.3961V46.8961H42.1562C41.4269 46.8961 40.7274 47.1858 40.2117 47.7016C39.696 48.2173 39.4062 48.9168 39.4062 49.6461C39.4062 50.3755 39.696 51.0749 40.2117 51.5907C40.7274 52.1064 41.4269 52.3961 42.1562 52.3961H47.6562V57.8961C47.6562 58.6255 47.946 59.3249 48.4617 59.8407C48.9774 60.3564 49.6769 60.6461 50.4062 60.6461C51.1356 60.6461 51.8351 60.3564 52.3508 59.8407C52.8665 59.3249 53.1562 58.6255 53.1562 57.8961V52.3961H58.6562C59.3856 52.3961 60.0851 52.1064 60.6008 51.5907C61.1165 51.0749 61.4062 50.3755 61.4062 49.6461Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconBook = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1286 1.09126C17.0605 0.986549 16.9674 0.900492 16.8576 0.840899C16.7479 0.781307 16.625 0.750066 16.5001 0.750011H12.0001C11.8607 0.749946 11.7241 0.788719 11.6055 0.861978C11.487 0.935238 11.3911 1.04009 11.3288 1.16476L9.00009 5.82301L6.67509 1.16476C6.61251 1.03951 6.51612 0.934287 6.39683 0.860988C6.27753 0.78769 6.14011 0.749247 6.00009 0.750011H1.5001C1.37514 0.749995 1.25216 0.781201 1.14233 0.840792C1.0325 0.900384 0.939293 0.986473 0.871188 1.09124C0.803083 1.196 0.762233 1.31613 0.75235 1.44069C0.742467 1.56526 0.763863 1.69032 0.814595 1.80451L4.30435 9.66676C3.94042 10.3907 3.75063 11.1897 3.7501 12C3.7501 13.3924 4.30322 14.7278 5.28778 15.7123C6.27235 16.6969 7.60771 17.25 9.00009 17.25C10.3925 17.25 11.7278 16.6969 12.7124 15.7123C13.697 14.7278 14.2501 13.3924 14.2501 12C14.2496 11.1897 14.0598 10.3907 13.6958 9.66676L17.1856 1.80451C17.2363 1.69029 17.2576 1.56521 17.2476 1.44065C17.2377 1.31609 17.1968 1.19599 17.1286 1.09126ZM2.6536 2.25001H5.53659L7.85184 6.88051C6.89733 7.09573 6.02208 7.57376 5.3251 8.26051L2.6536 2.25001ZM9.00009 15.75C8.25841 15.75 7.53339 15.5301 6.91671 15.118C6.30002 14.706 5.81938 14.1203 5.53555 13.4351C5.25172 12.7499 5.17746 11.9959 5.32215 11.2684C5.46685 10.541 5.824 9.87281 6.34844 9.34836C6.87289 8.82391 7.54108 8.46676 8.26851 8.32207C8.99593 8.17737 9.74993 8.25163 10.4352 8.53546C11.1204 8.81929 11.7061 9.29994 12.1181 9.91662C12.5302 10.5333 12.7501 11.2583 12.7501 12C12.7489 12.9942 12.3534 13.9473 11.6504 14.6503C10.9474 15.3534 9.99429 15.7488 9.00009 15.75ZM12.6788 8.26051C11.9808 7.57315 11.1042 7.09508 10.1483 6.88051L12.4636 2.25001H15.3466L12.6788 8.26051ZM11.2501 11.469L9.99984 12.5003L10.3906 14.25L9.00009 13.2503L7.60959 14.25L8.00034 12.5003L6.75009 11.469L8.25009 11.25L9.00009 9.75001L9.75009 11.25L11.2501 11.469Z"
        stroke="#4F4F4F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 2.25H12C11.2044 2.25 10.4413 2.56607 9.87868 3.12868C9.31607 3.69129 9 4.45435 9 5.25V15.75C9 15.1533 9.23705 14.581 9.65901 14.159C10.081 13.7371 10.6533 13.5 11.25 13.5H16.5V2.25Z"
        stroke="#4F4F4F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThumbUp = () => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.08268 20.9168H18.4202C19.1581 20.9215 19.8744 20.668 20.4451 20.2003C21.0158 19.7325 21.405 19.0798 21.5452 18.3554L22.9046 11.0637C22.9876 10.6175 22.9712 10.1584 22.8565 9.71928C22.7419 9.28013 22.5317 8.87169 22.241 8.52308C21.9404 8.16249 21.5639 7.87265 21.1385 7.67423C20.713 7.47582 20.249 7.3737 19.7796 7.37516H14.8098V3.2085C14.8098 1.06162 12.6087 0.0834961 10.5639 0.0834961C10.2877 0.0834961 10.0227 0.193243 9.82736 0.388593C9.63201 0.583944 9.52227 0.848896 9.52227 1.12516C9.52227 3.11162 9.1681 5.19808 8.7681 5.58766L5.86706 8.41683H1.08268C0.806415 8.41683 0.541463 8.52658 0.346113 8.72193C0.150762 8.91728 0.0410156 9.18223 0.0410156 9.4585V19.8752C0.0410156 20.1514 0.150762 20.4164 0.346113 20.6117C0.541463 20.8071 0.806415 20.9168 1.08268 20.9168ZM7.33268 9.89704L10.2223 7.08454C11.191 6.13975 11.4848 3.84287 11.5764 2.30954C12.141 2.44391 12.7316 2.70537 12.7316 3.2137V8.42204C12.7316 8.6983 12.8414 8.96326 13.0367 9.15861C13.2321 9.35396 13.497 9.4637 13.7733 9.4637H19.7848C19.9481 9.46255 20.1098 9.49741 20.2581 9.56583C20.4065 9.63425 20.5379 9.73453 20.6431 9.85954C20.7395 9.97328 20.8092 10.1072 20.847 10.2514C20.8849 10.3956 20.89 10.5464 20.8619 10.6929L19.5077 17.9845C19.454 18.2307 19.3159 18.4504 19.1173 18.6055C18.9187 18.7606 18.6721 18.8412 18.4202 18.8335H7.33268V9.89704ZM2.12435 10.5002H5.24935V18.8335H2.12435V10.5002Z"
      fill="currentColor"
    />
  </svg>
);

export const Medal = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7891 0.515478C22.6945 0.370044 22.5652 0.25052 22.4127 0.167753C22.2603 0.0849855 22.0896 0.0415951 21.9161 0.0415194H15.6661C15.4726 0.0414292 15.2828 0.0952797 15.1181 0.197029C14.9535 0.298779 14.8204 0.444402 14.7339 0.617561L11.4995 7.08735L8.27031 0.617561C8.18339 0.443607 8.04951 0.297458 7.88383 0.195654C7.71815 0.0938506 7.52727 0.0404579 7.33281 0.0415194H1.08281C0.909264 0.0414974 0.738458 0.0848381 0.585914 0.167604C0.43337 0.25037 0.303923 0.369938 0.209332 0.515446C0.114742 0.660954 0.058006 0.82779 0.0442792 1.0008C0.0305525 1.1738 0.0602698 1.3475 0.130731 1.5061L4.97761 12.4259C4.47216 13.4314 4.20856 14.5411 4.20781 15.6665C4.20781 17.6004 4.97604 19.4551 6.34349 20.8225C7.71095 22.19 9.56561 22.9582 11.4995 22.9582C13.4334 22.9582 15.288 22.19 16.6555 20.8225C18.0229 19.4551 18.7911 17.6004 18.7911 15.6665C18.7904 14.5411 18.5268 13.4314 18.0214 12.4259L22.8682 1.5061C22.9386 1.34746 22.9682 1.17374 22.9544 1.00074C22.9406 0.827739 22.8837 0.660933 22.7891 0.515478ZM2.6849 2.12485H6.68906L9.90469 8.5561C8.57897 8.85502 7.36335 9.51894 6.39531 10.4728L2.6849 2.12485ZM11.4995 20.8749C10.4694 20.8749 9.46239 20.5694 8.60589 19.9971C7.74938 19.4248 7.08182 18.6114 6.68761 17.6597C6.2934 16.708 6.19026 15.6607 6.39122 14.6504C6.59219 13.6401 7.08823 12.7121 7.81663 11.9837C8.54503 11.2553 9.47307 10.7592 10.4834 10.5583C11.4937 10.3573 12.5409 10.4604 13.4926 10.8546C14.4443 11.2489 15.2578 11.9164 15.8301 12.7729C16.4024 13.6294 16.7078 14.6364 16.7078 15.6665C16.7062 17.0473 16.1569 18.3711 15.1805 19.3475C14.2041 20.3239 12.8803 20.8732 11.4995 20.8749ZM16.6089 10.4728C15.6394 9.5181 14.4218 8.85412 13.0943 8.5561L16.3099 2.12485H20.3141L16.6089 10.4728ZM14.6245 14.929L12.888 16.3613L13.4307 18.7915L11.4995 17.403L9.56823 18.7915L10.1109 16.3613L8.37448 14.929L10.4578 14.6249L11.4995 12.5415L12.5411 14.6249L14.6245 14.929Z"
      fill="currentColor"
    />
  </svg>
);

export const StarOrange = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5007 0.604004C10.8952 0.604004 11.2559 0.826923 11.4324 1.17982L14.1187 6.55254L20.0256 7.41173C20.4179 7.46879 20.7439 7.74361 20.8664 8.12066C20.9889 8.49771 20.8867 8.91162 20.6029 9.18838L16.3038 13.38L17.2709 19.29C17.3348 19.6805 17.1718 20.0736 16.8503 20.3044C16.5288 20.5352 16.1042 20.5638 15.7546 20.3783L10.5007 17.5905L5.24674 20.3783C4.89713 20.5638 4.47259 20.5352 4.15106 20.3044C3.82954 20.0736 3.66659 19.6805 3.7305 19.29L4.69758 13.38L0.398494 9.18838C0.114634 8.91162 0.0124875 8.49771 0.134994 8.12066C0.257501 7.74361 0.58342 7.46879 0.975744 7.41173L6.88263 6.55254L9.56898 1.17982C9.74544 0.826923 10.1061 0.604004 10.5007 0.604004ZM10.5007 3.97491L8.50269 7.97089C8.35024 8.27579 8.05826 8.4868 7.72093 8.53586L3.36358 9.16966L6.54037 12.267C6.78379 12.5044 6.89608 12.8456 6.84118 13.1811L6.12569 17.5535L10.0124 15.4911C10.3178 15.3291 10.6836 15.3291 10.9889 15.4911L14.8757 17.5535L14.1602 13.1811C14.1053 12.8456 14.2176 12.5044 14.461 12.267L17.6378 9.16966L13.2804 8.53586C12.9431 8.4868 12.6511 8.27579 12.4987 7.97089L10.5007 3.97491Z"
      fill="#FF9549"
    />
  </svg>
);

export const IconCamera = () => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 1.64492C19.2 1.44492 18.8 1.44492 18.5 1.64492L14.1 4.64492V2.54492C14.1 1.44492 13.2 0.544922 12.1 0.544922H2C0.9 0.544922 0 1.44492 0 2.54492V12.5449C0 13.6449 0.9 14.5449 2 14.5449H12C13.1 14.5449 14 13.6449 14 12.5449V10.4449L18.4 13.4449C18.6 13.5449 18.8 13.6449 19 13.6449C19.2 13.6449 19.3 13.6449 19.5 13.5449C19.8 13.3449 20 13.0449 20 12.6449V2.54492C20 2.14492 19.8 1.84492 19.5 1.64492ZM12 12.5449H2V2.54492H12V6.54492V8.54492V12.5449ZM18 10.6449L14 7.94492V7.04492L18 4.34492V10.6449Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconStar = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="icon-primary"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00002 0.875C8.2841 0.875 8.5438 1.0355 8.67084 1.28959L10.605 5.15795L14.858 5.77656C15.1405 5.81765 15.3751 6.01552 15.4633 6.28699C15.5515 6.55847 15.478 6.85648 15.2736 7.05575L12.1783 10.0737L12.8746 14.3289C12.9206 14.6101 12.8032 14.8931 12.5717 15.0593C12.3403 15.2255 12.0346 15.2461 11.7829 15.1125L8.00002 13.1053L4.21718 15.1125C3.96546 15.2461 3.65979 15.2255 3.4283 15.0593C3.1968 14.8931 3.07947 14.6101 3.12549 14.3289L3.82179 10.0737L0.726447 7.05575C0.522068 6.85648 0.448522 6.55847 0.536727 6.28699C0.624932 6.01552 0.859594 5.81765 1.14207 5.77656L5.39502 5.15795L7.3292 1.28959C7.45625 1.0355 7.71594 0.875 8.00002 0.875ZM8.00002 3.30205L6.56147 6.17916C6.45171 6.39868 6.24148 6.55061 5.9986 6.58594L2.86131 7.04227L5.1486 9.27238C5.32386 9.44326 5.40471 9.68892 5.36518 9.93049L4.85003 13.0786L7.64849 11.5937C7.86833 11.4771 8.13172 11.4771 8.35156 11.5937L11.15 13.0786L10.6349 9.93049C10.5953 9.68892 10.6762 9.44326 10.8514 9.27238L13.1387 7.04227L10.0014 6.58594C9.75856 6.55061 9.54834 6.39868 9.43858 6.17916L8.00002 3.30205Z"
        fill="#FF9549"
      />
    </svg>
  );
};

export const IconThumbsUp = () => {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 12.75H11.6525C12.0952 12.7528 12.525 12.6007 12.8675 12.3201C13.2099 12.0394 13.4434 11.6478 13.5275 11.2131L14.3431 6.83813C14.393 6.57039 14.3831 6.29496 14.3143 6.03147C14.2455 5.76798 14.1194 5.52291 13.945 5.31375C13.7646 5.0974 13.5388 4.92349 13.2835 4.80444C13.0282 4.68539 12.7498 4.62412 12.4681 4.625H9.48625V2.125C9.48625 0.836875 8.16563 0.25 6.93875 0.25C6.77299 0.25 6.61402 0.315848 6.49681 0.433058C6.3796 0.550268 6.31375 0.70924 6.31375 0.875C6.31375 2.06687 6.10125 3.31875 5.86125 3.5525L4.12063 5.25H1.25C1.08424 5.25 0.925269 5.31585 0.808058 5.43306C0.690848 5.55027 0.625 5.70924 0.625 5.875V12.125C0.625 12.2908 0.690848 12.4497 0.808058 12.5669C0.925269 12.6842 1.08424 12.75 1.25 12.75ZM5 6.13812L6.73375 4.45062C7.315 3.88375 7.49125 2.50563 7.54625 1.58563C7.885 1.66625 8.23938 1.82313 8.23938 2.12813V5.25313C8.23938 5.41889 8.30522 5.57786 8.42243 5.69507C8.53964 5.81228 8.69862 5.87813 8.86438 5.87813H12.4713C12.5693 5.87743 12.6662 5.89835 12.7553 5.9394C12.8443 5.98045 12.9231 6.04062 12.9863 6.11563C13.0441 6.18387 13.0859 6.26421 13.1086 6.35073C13.1313 6.43726 13.1344 6.52777 13.1175 6.61563L12.305 10.9906C12.2728 11.1384 12.19 11.2702 12.0708 11.3632C11.9516 11.4562 11.8036 11.5046 11.6525 11.5H5V6.13812ZM1.875 6.5H3.75V11.5H1.875V6.5Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconWin = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2.01196H18V1.01196C18 0.746746 17.8946 0.492392 17.7071 0.304856C17.5196 0.11732 17.2652 0.0119629 17 0.0119629H5C4.73478 0.0119629 4.48043 0.11732 4.29289 0.304856C4.10536 0.492392 4 0.746746 4 1.01196V2.01196H1C0.734784 2.01196 0.48043 2.11732 0.292893 2.30486C0.105357 2.49239 0 2.74675 0 3.01196V5.01196C0.00362544 6.20945 0.437419 7.36577 1.22231 8.27016C2.00721 9.17455 3.09095 9.7668 4.276 9.93896C4.64939 11.2333 5.38786 12.3926 6.40301 13.2781C7.41816 14.1636 8.66698 14.7378 10 14.932V17.012H6C5.79004 17.0119 5.58538 17.078 5.41505 17.2007C5.24472 17.3235 5.11735 17.4968 5.051 17.696L4.051 20.696C4.00093 20.8463 3.9873 21.0064 4.01123 21.163C4.03517 21.3196 4.09598 21.4683 4.18866 21.5969C4.28134 21.7254 4.40323 21.83 4.54429 21.9022C4.68536 21.9744 4.84155 22.012 5 22.012H17C17.1584 22.0118 17.3144 21.9741 17.4554 21.9019C17.5963 21.8296 17.7181 21.725 17.8106 21.5965C17.9032 21.468 17.9639 21.3193 17.9878 21.1628C18.0117 21.0062 17.998 20.8462 17.948 20.696L16.948 17.696C16.8817 17.4969 16.7545 17.3238 16.5844 17.201C16.4142 17.0783 16.2098 17.0121 16 17.012H12V14.932C13.333 14.7378 14.5818 14.1636 15.597 13.2781C16.6121 12.3926 17.3506 11.2333 17.724 9.93896C18.9091 9.7668 19.9928 9.17455 20.7777 8.27016C21.5626 7.36577 21.9964 6.20945 22 5.01196V3.01196C22 2.74675 21.8946 2.49239 21.7071 2.30486C21.5196 2.11732 21.2652 2.01196 21 2.01196ZM4 7.84096C3.41549 7.63338 2.90951 7.25006 2.55144 6.74358C2.19338 6.23709 2.00076 5.63224 2 5.01196V4.01196H4V7.84096ZM15.279 19.012L15.612 20.012H6.387L6.721 19.012H15.279ZM16 8.01196C16 9.33805 15.4732 10.6098 14.5355 11.5475C13.5979 12.4852 12.3261 13.012 11 13.012C9.67392 13.012 8.40215 12.4852 7.46447 11.5475C6.52678 10.6098 6 9.33805 6 8.01196V2.01196H16V8.01196ZM20 5.01196C19.9992 5.63224 19.8066 6.23709 19.4486 6.74358C19.0905 7.25006 18.5845 7.63338 18 7.84096V4.01196H20V5.01196ZM9.667 7.67896L8 6.30396L10 6.01196L11 4.01196L12 6.01196L14 6.30396L12.333 7.67896L12.854 10.012L11 8.67896L9.146 10.012L9.667 7.67896Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconDownload = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4.54492C2 4.57046 2.01022 4.7145 2.29209 4.9644C2.57279 5.21327 3.03602 5.48307 3.69427 5.72991C5.0034 6.22084 6.87903 6.54492 9 6.54492C11.121 6.54492 12.9966 6.22084 14.3057 5.72991C14.964 5.48307 15.4272 5.21327 15.7079 4.9644C15.9898 4.7145 16 4.57046 16 4.54492C16 4.51939 15.9898 4.37535 15.7079 4.12545C15.4272 3.87658 14.964 3.60678 14.3057 3.35993C12.9966 2.86901 11.121 2.54492 9 2.54492C6.87903 2.54492 5.0034 2.86901 3.69427 3.35993C3.03602 3.60678 2.57279 3.87658 2.29209 4.12545C2.01022 4.37535 2 4.51939 2 4.54492ZM0 4.54492C0 3.74203 0.437492 3.09686 0.965273 2.62893C1.49422 2.15997 2.20256 1.78332 2.99202 1.48727C4.57833 0.892408 6.70269 0.544922 9 0.544922C11.2973 0.544922 13.4217 0.892408 15.008 1.48727C15.7974 1.78332 16.5058 2.15997 17.0347 2.62893C17.5625 3.09686 18 3.74203 18 4.54492V8.54492V12.5449V16.5449C18 17.3478 17.5625 17.993 17.0347 18.4609C16.5058 18.9299 15.7974 19.3065 15.008 19.6026C13.4217 20.1974 11.2973 20.5449 9 20.5449C6.70269 20.5449 4.57833 20.1974 2.99202 19.6026C2.20256 19.3065 1.49422 18.9299 0.965273 18.4609C0.437492 17.993 0 17.3478 0 16.5449V12.5449V8.54492V4.54492ZM2 8.54492C2 8.57046 2.01022 8.7145 2.29209 8.9644C2.57279 9.21327 3.03602 9.48307 3.69427 9.72991C5.0034 10.2208 6.87903 10.5449 9 10.5449C11.121 10.5449 12.9966 10.2208 14.3057 9.72991C14.964 9.48307 15.4272 9.21327 15.7079 8.9644C15.9898 8.7145 16 8.57046 16 8.54492V7.16111C15.6909 7.32473 15.3574 7.47155 15.008 7.60257C13.4217 8.19744 11.2973 8.54492 9 8.54492C6.70269 8.54492 4.57833 8.19744 2.99202 7.60257C2.64262 7.47155 2.3091 7.32473 2 7.16111V8.54492ZM2 11.1611V12.5449C2 12.5705 2.01022 12.7145 2.29209 12.9644C2.57279 13.2133 3.03602 13.4831 3.69427 13.7299C5.0034 14.2208 6.87903 14.5449 9 14.5449C11.121 14.5449 12.9966 14.2208 14.3057 13.7299C14.964 13.4831 15.4272 13.2133 15.7079 12.9644C15.9898 12.7145 16 12.5705 16 12.5449V11.1611C15.6909 11.3247 15.3574 11.4715 15.008 11.6026C13.4217 12.1974 11.2973 12.5449 9 12.5449C6.70269 12.5449 4.57833 12.1974 2.99202 11.6026C2.64262 11.4715 2.3091 11.3247 2 11.1611ZM2 15.1611V16.5449C2 16.5705 2.01022 16.7145 2.29209 16.9644C2.57279 17.2133 3.03602 17.4831 3.69427 17.7299C5.0034 18.2208 6.87903 18.5449 9 18.5449C11.121 18.5449 12.9966 18.2208 14.3057 17.7299C14.964 17.4831 15.4272 17.2133 15.7079 16.9644C15.9898 16.7145 16 16.5705 16 16.5449V15.1611C15.6909 15.3247 15.3574 15.4715 15.008 15.6026C13.4217 16.1974 11.2973 16.5449 9 16.5449C6.70269 16.5449 4.57833 16.1974 2.99202 15.6026C2.64262 15.4715 2.3091 15.3247 2 15.1611Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const IconSquares = () => {
  return (
    <svg
      className="icon-squares"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.54492C0 1.44035 0.89543 0.544922 2 0.544922H6C7.10457 0.544922 8 1.44035 8 2.54492V6.54492C8 7.64949 7.10457 8.54492 6 8.54492H2C0.895431 8.54492 0 7.64949 0 6.54492V2.54492ZM6 2.54492H2V6.54492H6V2.54492ZM10 2.54492C10 1.44035 10.8954 0.544922 12 0.544922H16C17.1046 0.544922 18 1.44035 18 2.54492V6.54492C18 7.64949 17.1046 8.54492 16 8.54492H12C10.8954 8.54492 10 7.64949 10 6.54492V2.54492ZM16 2.54492H12V6.54492H16V2.54492ZM0 12.5449C0 11.4404 0.89543 10.5449 2 10.5449H6C7.10457 10.5449 8 11.4404 8 12.5449V16.5449C8 17.6495 7.10457 18.5449 6 18.5449H2C0.895431 18.5449 0 17.6495 0 16.5449V12.5449ZM6 12.5449H2V16.5449H6V12.5449ZM10 12.5449C10 11.4404 10.8954 10.5449 12 10.5449H16C17.1046 10.5449 18 11.4404 18 12.5449V16.5449C18 17.6495 17.1046 18.5449 16 18.5449H12C10.8954 18.5449 10 17.6495 10 16.5449V12.5449ZM16 12.5449H12V16.5449H16V12.5449Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export const ArrowDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.918"
      height="6.159"
      viewBox="0 0 10.918 6.159"
    >
      <g id="arw" transform="translate(0.5 5.659) rotate(-90)">
        <g id="Group_9" data-name="Group 9" transform="translate(-0.5 -0.5)">
          <path
            id="Path_16"
            data-name="Path 16"
            d="M117.86,4.89,122.646.117a.4.4,0,1,1,.566.568l-4.5,4.489,4.5,4.488a.4.4,0,0,1-.567.568L117.86,5.458a.4.4,0,0,1,0-.568Z"
            transform="translate(-117.457 0.285)"
            fill="#333"
          />
          <path
            id="Path_16_-_Outline"
            data-name="Path 16 - Outline"
            d="M122.715-.5a.682.682,0,0,1,.486.2.682.682,0,0,1,.2.486.682.682,0,0,1-.2.485l-4.3,4.286,4.3,4.286a.687.687,0,0,1-.97.972l-4.786-4.773a.69.69,0,0,1-.2-.486.682.682,0,0,1,.2-.486L122.23-.3A.682.682,0,0,1,122.715-.5Zm0,10.347a.116.116,0,0,0,.082-.2l-4.7-4.691L122.8.268A.116.116,0,0,0,122.633.1l-4.786,4.773a.115.115,0,0,0,0,.163l4.786,4.773A.115.115,0,0,0,122.715,9.847Z"
            transform="translate(-117.242 0.5)"
            fill="#333"
          />
        </g>
      </g>
    </svg>
  );
};

export const IconTime = ({
  width = "20px",
  height = "21px",
  color = "#4A4A4A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.54492C5.58172 2.54492 2 6.12664 2 10.5449C2 14.9632 5.58172 18.5449 10 18.5449C14.4183 18.5449 18 14.9632 18 10.5449C18 6.12664 14.4183 2.54492 10 2.54492ZM0 10.5449C0 5.02207 4.47715 0.544922 10 0.544922C15.5228 0.544922 20 5.02207 20 10.5449C20 16.0678 15.5228 20.5449 10 20.5449C4.47715 20.5449 0 16.0678 0 10.5449ZM10 4.54492C10.5523 4.54492 11 4.99264 11 5.54492V10.1307L13.7071 12.8378C14.0976 13.2283 14.0976 13.8615 13.7071 14.252C13.3166 14.6426 12.6834 14.6426 12.2929 14.252L9.29289 11.252C9.10536 11.0645 9 10.8101 9 10.5449V5.54492C9 4.99264 9.44771 4.54492 10 4.54492Z"
        fill={color}
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.78049 0.83733 6.79048C0.00476617 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3166 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9966 8.08367 20.8365 5.28778 18.7744 3.22563C16.7122 1.16347 13.9163 0.00344047 11 0ZM11 20C9.13845 19.9567 7.32925 19.3753 5.791 18.326C6.44749 17.5947 7.2506 17.0098 8.14808 16.6095C9.04555 16.2091 10.0173 16.0021 11 16.0021C11.9827 16.0021 12.9545 16.2091 13.8519 16.6095C14.7494 17.0098 15.5525 17.5947 16.209 18.326C14.6836 19.4012 12.8663 19.9853 11 20ZM17.694 16.994C16.8517 16.052 15.8201 15.2985 14.6666 14.7825C13.513 14.2666 12.2636 13.9999 11 13.9999C9.73637 13.9999 8.48696 14.2666 7.33345 14.7825C6.17995 15.2985 5.14832 16.052 4.30601 16.994C3.14348 15.7004 2.38066 14.0977 2.10981 12.3798C1.83896 10.6618 2.07168 8.90213 2.77983 7.31364C3.48797 5.72514 4.64121 4.37585 6.10004 3.42896C7.55887 2.48208 9.26081 1.97816 11 1.97816C12.7392 1.97816 14.4411 2.48208 15.9 3.42896C17.3588 4.37585 18.512 5.72514 19.2202 7.31364C19.9283 8.90213 20.161 10.6618 19.8902 12.3798C19.6193 14.0977 18.8565 15.7004 17.694 16.994ZM11 5C10.2089 5 9.43552 5.2346 8.77772 5.67412C8.11993 6.11365 7.60724 6.73836 7.30449 7.46927C7.00174 8.20017 6.92252 9.00444 7.07686 9.78036C7.2312 10.5563 7.61217 11.269 8.17158 11.8284C8.73099 12.3878 9.44372 12.7688 10.2196 12.9231C10.9956 13.0775 11.7998 12.9983 12.5307 12.6955C13.2616 12.3928 13.8864 11.8801 14.3259 11.2223C14.7654 10.5645 15 9.79113 15 9C15 7.93913 14.5786 6.92172 13.8284 6.17157C13.0783 5.42143 12.0609 5 11 5ZM11 11C10.6044 11 10.2178 10.8827 9.88886 10.6629C9.55997 10.4432 9.30362 10.1308 9.15225 9.76537C9.00087 9.39991 8.96126 8.99778 9.03843 8.60982C9.1156 8.22186 9.30609 7.86549 9.58579 7.58579C9.8655 7.30608 10.2219 7.1156 10.6098 7.03843C10.9978 6.96126 11.3999 7.00087 11.7654 7.15224C12.1308 7.30362 12.4432 7.55996 12.6629 7.88886C12.8827 8.21776 13 8.60444 13 9C13 9.53043 12.7893 10.0391 12.4142 10.4142C12.0391 10.7893 11.5304 11 11 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowRight = ({ color = "#fff" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5.921"
      height="10.387"
      viewBox="0 0 5.921 10.387"
    >
      <g id="arrow" transform="translate(-97.139 0)">
        <path
          id="Path_27"
          data-name="Path 27"
          d="M102.846,5.707,98.38,10.173a.727.727,0,0,1-1.029-1.029L101.3,5.193,97.352,1.241A.727.727,0,0,1,98.38.213l4.466,4.466a.727.727,0,0,1,0,1.028Z"
          transform="translate(0 0)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const HeaderCard = ({
  mode,
}: {
  mode: "dark" | "light" | undefined;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.656"
      height="23.634"
      viewBox="0 0 23.656 23.634"
    >
      <g id="layer1" transform="translate(33.999 -246.006)">
        <path
          id="rect40272"
          d="M-31.781,255.006a2.248,2.248,0,0,0-2.186,2.62l1.921,11.087a2.837,2.837,0,0,0,2.8,2.331H-15.1a2.852,2.852,0,0,0,2.794-2.32l0-.012,1.919-11.075v0a2.239,2.239,0,0,0-2.183-2.629Zm0,1.688h19.217a.517.517,0,0,1,.524.631l0,.012-1.921,11.08a1.146,1.146,0,0,1-1.134.938H-29.249a1.138,1.138,0,0,1-1.134-.93L-32.3,257.337a.52.52,0,0,1,.523-.643Z"
          transform="translate(0 -1.403)"
          fill={mode === "light" ? "#333" : "white"}
          fillRule="evenodd"
        />
        <path
          id="path41727"
          d="M-25.419,246.062a.844.844,0,0,0-.47.445l-3.376,7.6a.844.844,0,0,0,.429,1.114.844.844,0,0,0,1.114-.429l3.376-7.6a.844.844,0,0,0-.429-1.114.844.844,0,0,0-.645-.016Z"
          transform="translate(-0.727 0)"
          fill={mode === "light" ? "#333" : "white"}
          fillRule="evenodd"
        />
        <path
          id="path41729"
          d="M-15.491,246.062a.844.844,0,0,0-.645.016.844.844,0,0,0-.429,1.114l3.376,7.6a.844.844,0,0,0,1.113.429.844.844,0,0,0,.429-1.114l-3.376-7.6a.844.844,0,0,0-.468-.445Z"
          transform="translate(-2.707 0)"
          fill={mode === "light" ? "#333" : "white"}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const LanguageIcon = ({
  mode,
}: {
  mode: "dark" | "light" | undefined;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <g
        id="_103571_globe_icon"
        data-name="103571_globe_icon"
        transform="translate(0 0.068)"
      >
        <g id="background" transform="translate(0 -0.068)">
          <rect
            id="Rectangle_4458"
            data-name="Rectangle 4458"
            width="14"
            height="14"
            fill="none"
          />
        </g>
        <g id="earth" transform="translate(0.223 0.155)">
          <path
            id="Path_32"
            data-name="Path 32"
            d="M6.776,0a6.777,6.777,0,1,0,6.777,6.776A6.778,6.778,0,0,0,6.776,0ZM.869,7.2H2.982a9.613,9.613,0,0,0,.3,2.117H1.429A5.908,5.908,0,0,1,.869,7.2ZM7.2,3.389V.937A6.128,6.128,0,0,1,9.078,3.39H7.2Zm2.189.847a8.731,8.731,0,0,1,.337,2.118H7.2V4.236ZM6.161,1.086c.074-.061.136-.109.192-.151V3.389H4.474A6.744,6.744,0,0,1,5.212,2.1,5.825,5.825,0,0,1,6.161,1.086Zm.192,3.15V6.354H3.829A8.629,8.629,0,0,1,4.17,4.236ZM2.982,6.354H.869a5.9,5.9,0,0,1,.559-2.118H3.287A9.624,9.624,0,0,0,2.982,6.354Zm.845.847H6.353V9.318H4.164A8.724,8.724,0,0,1,3.827,7.2Zm2.527,2.965v2.452a6.124,6.124,0,0,1-1.878-2.452Zm1.039,2.3c-.073.061-.136.109-.192.151V10.166H9.08a6.726,6.726,0,0,1-.738,1.284A5.819,5.819,0,0,1,7.392,12.468ZM7.2,9.318V7.2H9.724a8.65,8.65,0,0,1-.341,2.117ZM10.572,7.2h2.112a5.9,5.9,0,0,1-.559,2.117H10.267A9.664,9.664,0,0,0,10.572,7.2Zm0-.847a9.62,9.62,0,0,0-.305-2.118h1.859a5.894,5.894,0,0,1,.559,2.118Zm1.064-2.964H9.989a7.522,7.522,0,0,0-1.32-2.226A5.939,5.939,0,0,1,11.636,3.389ZM4.884,1.164A7.533,7.533,0,0,0,3.565,3.389H1.917A5.944,5.944,0,0,1,4.884,1.164Zm-2.965,9H3.565a7.521,7.521,0,0,0,1.318,2.224A5.939,5.939,0,0,1,1.919,10.166ZM8.67,12.389a7.53,7.53,0,0,0,1.319-2.224h1.646A5.938,5.938,0,0,1,8.67,12.389Z"
            fill={mode === "light" ? "#333" : "white"}
          />
        </g>
      </g>
    </svg>
  );
};

export const HeaderNotification = ({
  mode,
}: {
  mode: "dark" | "light" | undefined;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.311"
      height="26.784"
      viewBox="0 0 25.311 26.784"
    >
      <g
        id="_26._Notification"
        data-name="26. Notification"
        transform="matrix(0.978, 0.208, -0.208, 0.978, 3.787, -0.208)"
      >
        <path
          id="Path_2"
          data-name="Path 2"
          d="M21.131,14.008a3.518,3.518,0,0,1-1.037-2.5V8.592a8.592,8.592,0,1,0-17.185,0V11.5a3.518,3.518,0,0,1-1.037,2.5A2.98,2.98,0,0,0,3.98,19.094H6.824a4.774,4.774,0,0,0,9.356,0h2.845a2.98,2.98,0,0,0,2.107-5.087ZM11.5,21a2.864,2.864,0,0,1-2.688-1.909H14.19A2.864,2.864,0,0,1,11.5,21Zm7.522-3.819H3.98a1.07,1.07,0,0,1-.757-1.827,5.415,5.415,0,0,0,1.6-3.853V8.592a6.683,6.683,0,1,1,13.366,0V11.5a5.415,5.415,0,0,0,1.6,3.853,1.07,1.07,0,0,1-.757,1.827Z"
          transform="translate(0 0)"
          fill={mode === "light" ? "#333" : "white"}
        />
      </g>
    </svg>
  );
};

export const RedArrow = () => (
  <svg
    id="back-arw"
    xmlns="http://www.w3.org/2000/svg"
    width="19.407"
    height="17"
    viewBox="0 0 19.407 17"
  >
    <g id="Group_30" data-name="Group 30" transform="translate(9.675 0)">
      <g id="Group_29" data-name="Group 29" transform="translate(0 0)">
        <path
          id="Path_19"
          data-name="Path 19"
          d="M0,22.959l1.649-1.778,7.328,6.8a2.317,2.317,0,0,1-.007,3.429L1.659,38.181.01,36.4l7.246-6.713Z"
          transform="translate(0 -21.181)"
          fill="#ee312f"
        />
      </g>
    </g>
    <g id="Group_32" data-name="Group 32" transform="translate(0 7.285)">
      <g id="Group_31" data-name="Group 31" transform="translate(0 0)">
        <rect
          id="Rectangle_4181"
          data-name="Rectangle 4181"
          width="16.977"
          height="2.425"
          fill="#ee312f"
        />
      </g>
    </g>
  </svg>
);

export const ProfileIcon = ({
  mode,
}: {
  mode: "dark" | "light" | undefined;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.5"
      height="31.5"
      viewBox="0 0 31.5 31.5"
      className="profileIcon"
    >
      <g
        id="vuesax_linear_profile-circle"
        data-name="vuesax/linear/profile-circle"
        transform="translate(-492 -252)"
      >
        <g id="profile-circle" transform="translate(492 252)">
          <path
            id="Vector"
            d="M4.462,9.6a1,1,0,0,1-.137-.009H4.31l-.038,0a1,1,0,0,1-.158.007A5.3,5.3,0,1,1,9.61,4.3s0,0,0,.006A5.292,5.292,0,0,1,4.5,9.6ZM4.3,1a3.3,3.3,0,0,0-.186,6.595,2.317,2.317,0,0,1,.375,0A3.3,3.3,0,0,0,4.3,1Z"
            transform="translate(11.445 8.177)"
            fill={mode === "light" ? "#333" : "white"}
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M8.846,9.617a14.066,14.066,0,0,1-9.522-3.7,1,1,0,0,1-.319-.843A5.82,5.82,0,0,1,1.765.962l0,0A12.92,12.92,0,0,1,8.856-1,12.82,12.82,0,0,1,15.925.96a5.821,5.821,0,0,1,2.761,4.112,1,1,0,0,1-.319.843A14.066,14.066,0,0,1,8.846,9.617ZM1.092,4.8A12.067,12.067,0,0,0,8.846,7.617,12.067,12.067,0,0,0,16.6,4.8a4.234,4.234,0,0,0-1.79-2.184A10.811,10.811,0,0,0,8.856,1,10.913,10.913,0,0,0,2.879,2.623,4.233,4.233,0,0,0,1.092,4.8Z"
            transform="translate(6.904 20.258)"
            fill={mode === "light" ? "#333" : "white"}
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M13.125-1a14.125,14.125,0,0,1,9.988,24.113A14.125,14.125,0,1,1,3.137,3.137,14.033,14.033,0,0,1,13.125-1Zm0,26.25A12.125,12.125,0,0,0,21.7,4.551,12.125,12.125,0,1,0,4.551,21.7,12.046,12.046,0,0,0,13.125,25.25Z"
            transform="translate(2.625 2.625)"
            fill={mode === "light" ? "#333" : "white"}
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M0,0H31.5V31.5H0Z"
            transform="translate(31.5 31.5) rotate(180)"
            fill="none"
            opacity="0"
          />
        </g>
      </g>
    </svg>
  );
};

export const ProgressTropy = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2H18V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0H5C4.73478 0 4.48043 0.105357 4.29289 0.292893C4.10536 0.48043 4 0.734784 4 1V2H1C0.734784 2 0.48043 2.10536 0.292893 2.29289C0.105357 2.48043 0 2.73478 0 3V5C0.00362544 6.19749 0.437419 7.3538 1.22231 8.2582C2.00721 9.16259 3.09095 9.75484 4.276 9.927C4.64939 11.2213 5.38786 12.3806 6.40301 13.2661C7.41816 14.1516 8.66698 14.7258 10 14.92V17H6C5.79004 16.9999 5.58538 17.066 5.41505 17.1888C5.24472 17.3115 5.11735 17.4848 5.051 17.684L4.051 20.684C4.00093 20.8343 3.9873 20.9944 4.01123 21.151C4.03517 21.3077 4.09598 21.4564 4.18866 21.5849C4.28134 21.7134 4.40323 21.8181 4.54429 21.8903C4.68536 21.9624 4.84155 22 5 22H17C17.1584 21.9999 17.3144 21.9621 17.4554 21.8899C17.5963 21.8177 17.7181 21.713 17.8106 21.5845C17.9032 21.456 17.9639 21.3074 17.9878 21.1508C18.0117 20.9942 17.998 20.8343 17.948 20.684L16.948 17.684C16.8817 17.485 16.7545 17.3118 16.5844 17.1891C16.4142 17.0663 16.2098 17.0002 16 17H12V14.92C13.333 14.7258 14.5818 14.1516 15.597 13.2661C16.6121 12.3806 17.3506 11.2213 17.724 9.927C18.9091 9.75484 19.9928 9.16259 20.7777 8.2582C21.5626 7.3538 21.9964 6.19749 22 5V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM4 7.829C3.41549 7.62142 2.90951 7.2381 2.55144 6.73161C2.19338 6.22513 2.00076 5.62027 2 5V4H4V7.829ZM15.279 19L15.612 20H6.387L6.721 19H15.279ZM16 8C16 9.32608 15.4732 10.5979 14.5355 11.5355C13.5979 12.4732 12.3261 13 11 13C9.67392 13 8.40215 12.4732 7.46447 11.5355C6.52678 10.5979 6 9.32608 6 8V2H16V8ZM20 5C19.9992 5.62027 19.8066 6.22513 19.4486 6.73161C19.0905 7.2381 18.5845 7.62142 18 7.829V4H20V5ZM9.667 7.667L8 6.292L10 6L11 4L12 6L14 6.292L12.333 7.667L12.854 10L11 8.667L9.146 10L9.667 7.667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HeaderUser = ({
  mode,
}: {
  mode: "dark" | "light" | undefined;
}) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="50"
        height="50"
        rx="25"
        fill={mode === "light" ? "#F8F8F8" : "#4A4A4A"}
      />
      <path
        d="M23 17C20.7909 17 19 18.7909 19 21C19 23.2091 20.7909 25 23 25C25.2091 25 27 23.2091 27 21C27 18.7909 25.2091 17 23 17ZM17 21C17 17.6863 19.6863 15 23 15C26.3137 15 29 17.6863 29 21C29 24.3137 26.3137 27 23 27C19.6863 27 17 24.3137 17 21ZM32 24C32.5523 24 33 24.4477 33 25V26H34C34.5523 26 35 26.4477 35 27C35 27.5523 34.5523 28 34 28H33V29C33 29.5523 32.5523 30 32 30C31.4477 30 31 29.5523 31 29V28H30C29.4477 28 29 27.5523 29 27C29 26.4477 29.4477 26 30 26H31V25C31 24.4477 31.4477 24 32 24ZM19.5 31C18.2405 31 17 32.2135 17 34C17 34.5523 16.5523 35 16 35C15.4477 35 15 34.5523 15 34C15 31.3682 16.8935 29 19.5 29H26.5C29.1065 29 31 31.3682 31 34C31 34.5523 30.5523 35 30 35C29.4477 35 29 34.5523 29 34C29 32.2135 27.7595 31 26.5 31H19.5Z"
        fill={mode === "dark" ? "#F8F8F8" : "#4A4A4A"}
      />
    </svg>
  );
};

export const CloseIcon = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.699143 0.462083C1.08967 0.0715584 1.72283 0.0715584 2.11336 0.462083L7.40625 5.75498L12.6991 0.462083C13.0897 0.0715584 13.7228 0.0715584 14.1134 0.462083C14.5039 0.852607 14.5039 1.48577 14.1134 1.8763L8.82046 7.16919L14.1134 12.4621C14.5039 12.8526 14.5039 13.4858 14.1134 13.8763C13.7228 14.2668 13.0897 14.2668 12.6991 13.8763L7.40625 8.5834L2.11336 13.8763C1.72283 14.2668 1.08967 14.2668 0.699143 13.8763C0.308619 13.4858 0.308619 12.8526 0.699143 12.4621L5.99204 7.16919L0.699143 1.8763C0.308619 1.48577 0.308619 0.852607 0.699143 0.462083Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export const CloseMobileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="close" transform="translate(0 -0.005)">
        <g id="Group_68" data-name="Group 68" transform="translate(0 0.005)">
          <path
            id="Path_31"
            data-name="Path 31"
            d="M15.367,2.638a9,9,0,1,0,0,12.734A9.014,9.014,0,0,0,15.367,2.638Zm-2.653,9.02a.75.75,0,1,1-1.061,1.061L9,10.066,6.349,12.718a.75.75,0,0,1-1.061-1.061L7.939,9,5.287,6.352A.75.75,0,0,1,6.348,5.291L9,7.944l2.652-2.653a.75.75,0,0,1,1.061,1.061L10.061,9Z"
            transform="translate(0 -0.005)"
            fill="#afafaf"
          />
        </g>
      </g>
    </svg>
  );
};

export const PdfIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.757"
      height="17.157"
      viewBox="0 0 13.757 17.157"
    >
      <path
        id="Union_89"
        data-name="Union 89"
        d="M-469.691,8979.157a2.311,2.311,0,0,1-2.31-2.31V8964.31a2.313,2.313,0,0,1,2.31-2.31h7.2l4.243,4.743v10.1a2.309,2.309,0,0,1-2.308,2.31Zm-1.093-14.848v12.538a1.094,1.094,0,0,0,1.093,1.093h9.14a1.092,1.092,0,0,0,1.091-1.093v-9.262h-3.908v-4.369h-6.323A1.1,1.1,0,0,0-470.784,8964.31Zm8.633,2.06h1.938l-1.938-2.168Zm-.356,8.354V8969.6h2.639v1.039H-461.6v1.075h1.456v1.012H-461.6v2Zm-4.122,0V8969.6h1.568c1.217,0,2.062,1.053,2.062,2.578,0,1.5-.825,2.549-2.006,2.549Zm.908-1.039h.626c.717,0,1.138-.561,1.138-1.51,0-.971-.444-1.539-1.194-1.539h-.57Zm-4.43,1.039V8969.6h1.681c.845,0,1.411.688,1.411,1.713s-.566,1.71-1.411,1.71h-.773v1.7Zm.908-2.7h.57c.437,0,.656-.236.656-.712s-.219-.714-.656-.714h-.57Z"
        transform="translate(472.001 -8962)"
        fill="#ee312f"
      />
    </svg>
  );
};

export const DownloadIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C8.55228 0 9 0.447715 9 1V11.5858L11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L7 11.5858V1C7 0.447715 7.44772 0 8 0ZM1 15C1.55228 15 2 15.4477 2 16V18H14V16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16V18C16 19.1046 15.1046 20 14 20H2C0.895431 20 0 19.1046 0 18V16C0 15.4477 0.447715 15 1 15Z"
      fill="currentColor"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29289 0.292893C7.68342 -0.0976311 8.31658 -0.0976311 8.70711 0.292893L11.7071 3.29289C12.0976 3.68342 12.0976 4.31658 11.7071 4.70711C11.3166 5.09763 10.6834 5.09763 10.2929 4.70711L9 3.41421V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V3.41421L5.70711 4.70711C5.31658 5.09763 4.68342 5.09763 4.29289 4.70711C3.90237 4.31658 3.90237 3.68342 4.29289 3.29289L7.29289 0.292893ZM0 9C0 7.89543 0.895431 7 2 7H4C4.55228 7 5 7.44772 5 8C5 8.55228 4.55228 9 4 9H2V18H14V9H12C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7H14C15.1046 7 16 7.89543 16 9V18C16 19.1046 15.1046 20 14 20H2C0.895431 20 0 19.1046 0 18V9Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const FiltersIcon = ({ color }: { color: string }) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 2C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4C5.55228 4 6 3.55228 6 3C6 2.44772 5.55228 2 5 2ZM2.17071 2C2.58254 0.834808 3.69378 0 5 0C6.30622 0 7.41746 0.834808 7.82929 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H7.82929C7.41746 5.16519 6.30622 6 5 6C3.69378 6 2.58254 5.16519 2.17071 4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H2.17071ZM11 8C10.4477 8 10 8.44772 10 9C10 9.55229 10.4477 10 11 10C11.5523 10 12 9.55229 12 9C12 8.44772 11.5523 8 11 8ZM8.17071 8C8.58254 6.83481 9.69378 6 11 6C12.3062 6 13.4175 6.83481 13.8293 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H13.8293C13.4175 11.1652 12.3062 12 11 12C9.69378 12 8.58254 11.1652 8.17071 10H1C0.447715 10 0 9.55229 0 9C0 8.44772 0.447715 8 1 8H8.17071ZM5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14ZM2.17071 14C2.58254 12.8348 3.69378 12 5 12C6.30622 12 7.41746 12.8348 7.82929 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H7.82929C7.41746 17.1652 6.30622 18 5 18C3.69378 18 2.58254 17.1652 2.17071 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H2.17071Z"
      fill={color}
    />
  </svg>
);

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M16 9v-4l8 7-8 7v-4h-8v-6h8zm-2 10v-.083c-1.178.685-2.542 1.083-4 1.083-4.411 0-8-3.589-8-8s3.589-8 8-8c1.458 0 2.822.398 4 1.083v-2.245c-1.226-.536-2.577-.838-4-.838-5.522 0-10 4.477-10 10s4.478 10 10 10c1.423 0 2.774-.302 4-.838v-2.162z" />
    </svg>
  );
};

export const LessonsIcon = () => (
  <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5013 19.1668H9.83464C10.0556 19.1668 10.2676 19.079 10.4239 18.9228C10.5802 18.7665 10.668 18.5545 10.668 18.3335V8.3335C10.668 8.11248 10.5802 7.90052 10.4239 7.74424C10.2676 7.58796 10.0556 7.50016 9.83464 7.50016H1.5013C1.28029 7.50016 1.06833 7.58796 0.912046 7.74424C0.755766 7.90052 0.667969 8.11248 0.667969 8.3335V18.3335C0.667969 18.5545 0.755766 18.7665 0.912046 18.9228C1.06833 19.079 1.28029 19.1668 1.5013 19.1668ZM2.33464 9.16683H9.0013V17.5002H2.33464V9.16683ZM12.3346 15.0002V5.8335H4.83464C4.61362 5.8335 4.40166 5.7457 4.24538 5.58942C4.0891 5.43314 4.0013 5.22118 4.0013 5.00016C4.0013 4.77915 4.0891 4.56719 4.24538 4.41091C4.40166 4.25463 4.61362 4.16683 4.83464 4.16683H13.168C13.389 4.16683 13.6009 4.25463 13.7572 4.41091C13.9135 4.56719 14.0013 4.77915 14.0013 5.00016V15.0002C14.0013 15.2212 13.9135 15.4331 13.7572 15.5894C13.6009 15.7457 13.389 15.8335 13.168 15.8335C12.947 15.8335 12.735 15.7457 12.5787 15.5894C12.4224 15.4331 12.3346 15.2212 12.3346 15.0002ZM17.3346 1.66683V12.5002C17.3346 12.7212 17.2468 12.9331 17.0906 13.0894C16.9343 13.2457 16.7223 13.3335 16.5013 13.3335C16.2803 13.3335 16.0683 13.2457 15.912 13.0894C15.7558 12.9331 15.668 12.7212 15.668 12.5002V2.50016H8.16797C7.94696 2.50016 7.73499 2.41237 7.57871 2.25609C7.42243 2.0998 7.33464 1.88784 7.33464 1.66683C7.33464 1.44582 7.42243 1.23385 7.57871 1.07757C7.73499 0.921293 7.94696 0.833496 8.16797 0.833496H16.5013C16.7223 0.833496 16.9343 0.921293 17.0906 1.07757C17.2468 1.23385 17.3346 1.44582 17.3346 1.66683Z" />
  </svg>
);

export const ResizeIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    x="0px"
    y="0px"
    viewBox="0 0 357.18 357.18"
  >
    <g>
      <g>
        <path
          d="M123.292,96.7c-0.128-0.196-0.112-0.408-0.284-0.58L65.456,38.564l31.268,0.048c7.396,0,13.82-6.42,13.816-13.812
   l0.004-10.524c0-7.648-6.22-13.868-13.864-13.868H15.04C11.264,0.408,7.7,2,5.072,4.68c-2.608,2.596-4.164,6.088-4.164,9.86V97.9
   c-0.004,7.64,6.216,13.86,13.86,13.86l10.528,0.008c7.636,0,13.848-6.212,13.852-13.852l-0.02-31.32L89,116.472
   c0.028,0.024,0.052,0.048,0.072,0.072l6.428,6.42c5.404,5.408,14.104,5.284,19.512-0.124l7.44-7.436
   C127.576,110.272,127.884,102.144,123.292,96.7z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M357.132,260.884c0-7.648-6.212-13.876-13.856-13.876L332.756,247c-7.384-0.008-13.836,6.444-13.836,13.836l0.048,31.272
   L261.64,234.78c-0.18-0.18-0.5-0.268-0.696-0.4c-5.444-4.6-13.688-4.396-18.812,0.728l-7.444,7.444
   c-5.4,5.4-5.316,14.32,0.1,19.736l6.42,6.42c0.024,0.024,0.048,0.048,0.072,0.072l49.656,49.656l-31.312-0.016
   c-7.384,0-13.852,6.46-13.852,13.852l0.024,10.544c-0.008,7.64,6.228,13.876,13.868,13.868l83.38,0.032
   c3.688-0.008,7.196-1.4,9.824-4.032l0.376-0.376c2.532-2.54,3.936-6.048,3.936-9.728L357.132,260.884z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M122.308,242.804l-7.448-7.452c-5.12-5.116-13.412-5.24-18.852-0.648c-0.196,0.132-0.56,0.296-0.736,0.468l-57.084,57.084
   l0.036-31.288c0.004-3.684-1.42-7.14-4.04-9.764c-2.624-2.62-6.104-4.072-9.792-4.064l-10.524-0.008
   c-3.824,0-7.288,1.556-9.8,4.072C1.552,253.712,0,257.18,0,261v81.64c0,3.78,1.52,7.32,4.272,9.968
   c2.544,2.648,6.084,4.164,9.86,4.164h83.36c7.644,0.008,13.864-6.212,13.864-13.852v-10.532c0-3.688-1.436-7.156-4.064-9.78
   c-2.62-2.628-6.084-4.056-9.772-4.056l-31.296,0.024l49.412-49.404c0.024-0.024,0.044-0.04,0.064-0.064l5.584-5.584l0.84-0.844
   C127.532,257.272,127.708,248.204,122.308,242.804z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M356.348,14.576c0-3.772-1.516-7.312-4.264-9.964c-2.556-2.648-6.096-4.172-9.868-4.172h-81.64
   c-3.82,0-7.288,1.556-9.796,4.064c-2.516,2.516-4.072,5.976-4.072,9.796v10.524c0,3.696,1.44,7.164,4.064,9.788
   c2.616,2.62,6.084,4.056,9.772,4.056l31.288-0.04l-57.4,57.4c-0.172,0.18-0.312,0.516-0.444,0.712
   c-4.592,5.444-4.436,13.704,0.68,18.82l7.452,7.452c5.4,5.4,14.412,5.276,19.82-0.132l6.42-6.42
   c0.032-0.024,0.048-0.048,0.072-0.072l49.728-49.724l-0.032,31.296c0,3.692,1.416,7.14,4.04,9.756
   c2.624,2.636,6.108,4.08,9.788,4.072l10.532,0.008c7.648,0,13.864-6.22,13.864-13.868L356.348,14.576z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M205.732,151.704c-15.004-14.992-39.396-14.992-54.392,0c-14.996,14.992-14.996,39.392,0.004,54.392
   c14.992,14.992,39.392,14.992,54.388,0C220.724,191.104,220.724,166.696,205.732,151.704z"
        />
      </g>
    </g>
  </svg>
);

export const IconQuestion = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="#4A4A4A"
    />
    <path
      d="M10 12C9.44771 12 9 11.5523 9 11V10C9 9.44771 9.44772 9 10 9C10.5523 9 11 9.44771 11 10V11C11 11.5523 10.5523 12 10 12Z"
      fill="#4A4A4A"
    />
    <path
      d="M8.5 14.5C8.5 13.6716 9.17157 13 10 13C10.8284 13 11.5 13.6716 11.5 14.5C11.5 15.3284 10.8284 16 10 16C9.17157 16 8.5 15.3284 8.5 14.5Z"
      fill="#4A4A4A"
    />
    <path
      d="M10.3899 5.81137C9.4329 5.7658 8.63039 6.3004 8.48639 7.1644C8.3956 7.70917 7.88037 8.07719 7.3356 7.9864C6.79083 7.8956 6.42281 7.38037 6.51361 6.8356C6.86961 4.69961 8.8171 3.73421 10.4851 3.81363C11.3395 3.85432 12.2176 4.16099 12.8937 4.79278C13.5866 5.44027 14 6.36777 14 7.5C14 8.79131 13.4919 9.74892 12.6172 10.3321C11.8141 10.8675 10.8295 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44771 9.44772 9 10 9C10.6705 9 11.1859 8.88252 11.5078 8.66795C11.7581 8.50109 12 8.2087 12 7.5C12 6.88224 11.7884 6.49723 11.5282 6.2541C11.2512 5.99526 10.848 5.83318 10.3899 5.81137Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconUsers = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.73 15.663C19.2249 15.0504 19.4964 14.2875 19.5 13.5C19.5 12.5717 19.1313 11.6815 18.4749 11.0251C17.8185 10.3687 16.9283 10 16 10C15.0717 10 14.1815 10.3687 13.5251 11.0251C12.8687 11.6815 12.5 12.5717 12.5 13.5C12.5036 14.2875 12.7751 15.0504 13.27 15.663C12.3527 16.1338 11.5713 16.8317 11 17.69C10.4287 16.8317 9.64727 16.1338 8.73 15.663C9.22488 15.0504 9.49645 14.2875 9.5 13.5C9.5 12.5717 9.13125 11.6815 8.47487 11.0251C7.8185 10.3687 6.92826 10 6 10C5.07174 10 4.1815 10.3687 3.52513 11.0251C2.86875 11.6815 2.5 12.5717 2.5 13.5C2.50355 14.2875 2.77512 15.0504 3.27 15.663C2.28657 16.1655 1.4609 16.9296 0.883935 17.8713C0.30697 18.813 0.00109519 19.8956 0 21C0 21.2652 0.105357 21.5196 0.292893 21.7071C0.48043 21.8946 0.734784 22 1 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21C21.9989 19.8956 21.693 18.813 21.1161 17.8713C20.5391 16.9296 19.7134 16.1655 18.73 15.663ZM6 12C6.29667 12 6.58668 12.088 6.83336 12.2528C7.08003 12.4176 7.27229 12.6519 7.38582 12.926C7.49935 13.2001 7.52906 13.5017 7.47118 13.7926C7.4133 14.0836 7.27044 14.3509 7.06066 14.5607C6.85088 14.7704 6.58361 14.9133 6.29264 14.9712C6.00166 15.0291 5.70006 14.9994 5.42597 14.8858C5.15189 14.7723 4.91762 14.58 4.7528 14.3334C4.58797 14.0867 4.5 13.7967 4.5 13.5C4.5 13.1022 4.65804 12.7206 4.93934 12.4393C5.22064 12.158 5.60218 12 6 12ZM2.127 20C2.34868 19.1414 2.84942 18.3807 3.55048 17.8377C4.25155 17.2946 5.11321 16.9999 6 16.9999C6.88679 16.9999 7.74845 17.2946 8.44952 17.8377C9.15058 18.3807 9.65132 19.1414 9.873 20H2.127ZM16 12C16.2967 12 16.5867 12.088 16.8334 12.2528C17.08 12.4176 17.2723 12.6519 17.3858 12.926C17.4993 13.2001 17.5291 13.5017 17.4712 13.7926C17.4133 14.0836 17.2704 14.3509 17.0607 14.5607C16.8509 14.7704 16.5836 14.9133 16.2926 14.9712C16.0017 15.0291 15.7001 14.9994 15.426 14.8858C15.1519 14.7723 14.9176 14.58 14.7528 14.3334C14.588 14.0867 14.5 13.7967 14.5 13.5C14.5 13.1022 14.658 12.7206 14.9393 12.4393C15.2206 12.158 15.6022 12 16 12ZM12.127 20C12.3487 19.1414 12.8494 18.3807 13.5505 17.8377C14.2516 17.2946 15.1132 16.9999 16 16.9999C16.8868 16.9999 17.7484 17.2946 18.4495 17.8377C19.1506 18.3807 19.6513 19.1414 19.873 20H12.127ZM10 9V6H7C6.73478 6 6.48043 5.89464 6.29289 5.70711C6.10536 5.51957 6 5.26522 6 5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H10V1C10 0.734784 10.1054 0.48043 10.2929 0.292893C10.4804 0.105357 10.7348 0 11 0C11.2652 0 11.5196 0.105357 11.7071 0.292893C11.8946 0.48043 12 0.734784 12 1V4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6H12V9C12 9.26522 11.8946 9.51957 11.7071 9.70711C11.5196 9.89464 11.2652 10 11 10C10.7348 10 10.4804 9.89464 10.2929 9.70711C10.1054 9.51957 10 9.26522 10 9Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconLocation = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7852 2.24658C8.38516 2.24658 4.78516 5.84658 4.78516 10.2466C4.78516 15.6466 11.7852 21.7466 12.0852 22.0466C12.2852 22.1466 12.5852 22.2466 12.7852 22.2466C12.9852 22.2466 13.2852 22.1466 13.4852 22.0466C13.7852 21.7466 20.7852 15.6466 20.7852 10.2466C20.7852 5.84658 17.1852 2.24658 12.7852 2.24658ZM12.7852 19.9466C10.6852 17.9466 6.78516 13.6466 6.78516 10.2466C6.78516 6.94658 9.48516 4.24658 12.7852 4.24658C16.0852 4.24658 18.7852 6.94658 18.7852 10.2466C18.7852 13.5466 14.8852 17.9466 12.7852 19.9466ZM12.7852 6.24658C10.5852 6.24658 8.78516 8.04658 8.78516 10.2466C8.78516 12.4466 10.5852 14.2466 12.7852 14.2466C14.9852 14.2466 16.7852 12.4466 16.7852 10.2466C16.7852 8.04658 14.9852 6.24658 12.7852 6.24658ZM12.7852 12.2466C11.6852 12.2466 10.7852 11.3466 10.7852 10.2466C10.7852 9.14658 11.6852 8.24658 12.7852 8.24658C13.8852 8.24658 14.7852 9.14658 14.7852 10.2466C14.7852 11.3466 13.8852 12.2466 12.7852 12.2466Z"
      fill="currentColor"
    />
  </svg>
);

export const IconChevronDoubleUp = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.07805 0.539475C7.46857 0.148951 8.10174 0.148951 8.49226 0.539475L14.4923 6.53948C14.8828 6.93 14.8828 7.56317 14.4923 7.95369C14.1017 8.34421 13.4686 8.34421 13.078 7.95369L7.78516 2.6608L2.49226 7.95369C2.10174 8.34421 1.46857 8.34421 1.07805 7.95369C0.687525 7.56316 0.687525 6.93 1.07805 6.53947L7.07805 0.539475ZM7.78516 8.6608L2.49226 13.9537C2.10174 14.3442 1.46857 14.3442 1.07805 13.9537C0.687525 13.5632 0.687525 12.93 1.07805 12.5395L7.07805 6.53947C7.46857 6.14895 8.10174 6.14895 8.49226 6.53948L14.4923 12.5395C14.8828 12.93 14.8828 13.5632 14.4923 13.9537C14.1017 14.3442 13.4686 14.3442 13.078 13.9537L7.78516 8.6608Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconChevronDoubleDown = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.07805 0.539475C1.46857 0.148951 2.10174 0.148951 2.49226 0.539475L7.78516 5.83237L13.0781 0.539477C13.4686 0.148953 14.1017 0.148953 14.4923 0.539477C14.8828 0.930002 14.8828 1.56317 14.4923 1.95369L8.49226 7.95369C8.10174 8.34421 7.46857 8.34421 7.07805 7.95369L1.07805 1.95369C0.687526 1.56316 0.687526 0.929999 1.07805 0.539475ZM1.07805 6.53947C1.46857 6.14895 2.10174 6.14895 2.49226 6.53947L7.78516 11.8324L13.078 6.53948C13.4686 6.14895 14.1017 6.14895 14.4923 6.53948C14.8828 6.93 14.8828 7.56317 14.4923 7.95369L8.49226 13.9537C8.10174 14.3442 7.46857 14.3442 7.07805 13.9537L1.07805 7.95369C0.687525 7.56316 0.687525 6.93 1.07805 6.53947Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconUser = () => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.78516 2.24658C7.57602 2.24658 5.78516 4.03744 5.78516 6.24658C5.78516 8.45572 7.57602 10.2466 9.78516 10.2466C11.9943 10.2466 13.7852 8.45572 13.7852 6.24658C13.7852 4.03744 11.9943 2.24658 9.78516 2.24658ZM3.78516 6.24658C3.78516 2.93287 6.47145 0.246582 9.78516 0.246582C13.0989 0.246582 15.7852 2.93287 15.7852 6.24658C15.7852 9.56029 13.0989 12.2466 9.78516 12.2466C6.47145 12.2466 3.78516 9.56029 3.78516 6.24658ZM5.78516 16.2466C4.1283 16.2466 2.78516 17.5897 2.78516 19.2466C2.78516 19.7989 2.33744 20.2466 1.78516 20.2466C1.23287 20.2466 0.785156 19.7989 0.785156 19.2466C0.785156 16.4852 3.02373 14.2466 5.78516 14.2466H13.7852C16.5466 14.2466 18.7852 16.4852 18.7852 19.2466C18.7852 19.7989 18.3374 20.2466 17.7852 20.2466C17.2329 20.2466 16.7852 19.7989 16.7852 19.2466C16.7852 17.5897 15.442 16.2466 13.7852 16.2466H5.78516Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconDoubleUser = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.78516 2.24658C6.57602 2.24658 4.78516 4.03744 4.78516 6.24658C4.78516 8.45572 6.57602 10.2466 8.78516 10.2466C10.9943 10.2466 12.7852 8.45572 12.7852 6.24658C12.7852 4.03744 10.9943 2.24658 8.78516 2.24658ZM2.78516 6.24658C2.78516 2.93287 5.47145 0.246582 8.78516 0.246582C12.0989 0.246582 14.7852 2.93287 14.7852 6.24658C14.7852 9.56029 12.0989 12.2466 8.78516 12.2466C5.47145 12.2466 2.78516 9.56029 2.78516 6.24658ZM15.6136 2.00394C16.0041 1.61342 16.6373 1.61342 17.0278 2.00394C19.3709 4.34709 19.3709 8.14608 17.0278 10.4892C16.6373 10.8797 16.0041 10.8797 15.6136 10.4892C15.2231 10.0987 15.2231 9.46553 15.6136 9.07501C17.1757 7.51291 17.1757 4.98025 15.6136 3.41815C15.2231 3.02763 15.2231 2.39447 15.6136 2.00394ZM16.315 15.004C16.449 14.4683 16.9919 14.1425 17.5277 14.2764C18.8556 14.6084 19.6962 15.4575 20.1796 16.4244C20.6474 17.3599 20.7852 18.4037 20.7852 19.2466C20.7852 19.7989 20.3374 20.2466 19.7852 20.2466C19.2329 20.2466 18.7852 19.7989 18.7852 19.2466C18.7852 18.5895 18.6729 17.8832 18.3907 17.3188C18.1242 16.7857 17.7147 16.3847 17.0426 16.2167C16.5068 16.0828 16.1811 15.5398 16.315 15.004ZM5.28516 16.2466C4.0257 16.2466 2.78516 17.4601 2.78516 19.2466C2.78516 19.7989 2.33744 20.2466 1.78516 20.2466C1.23287 20.2466 0.785156 19.7989 0.785156 19.2466C0.785156 16.6148 2.67862 14.2466 5.28516 14.2466H12.2852C14.8917 14.2466 16.7852 16.6148 16.7852 19.2466C16.7852 19.7989 16.3374 20.2466 15.7852 20.2466C15.2329 20.2466 14.7852 19.7989 14.7852 19.2466C14.7852 17.4601 13.5446 16.2466 12.2852 16.2466H5.28516Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconEye = () => (
  <svg
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7852 7.24658C13.7852 8.90344 12.442 10.2466 10.7852 10.2466C9.1283 10.2466 7.78516 8.90344 7.78516 7.24658C7.78516 5.58973 9.1283 4.24658 10.7852 4.24658C12.442 4.24658 13.7852 5.58973 13.7852 7.24658Z"
      fill="#4A4A4A"
    />
    <path
      d="M20.6796 6.79937C18.5214 2.48293 14.6883 0.246582 10.7852 0.246582C6.88203 0.246582 3.04895 2.48293 0.890729 6.79937C0.749965 7.0809 0.749965 7.41227 0.890729 7.6938C3.04895 12.0102 6.88203 14.2466 10.7852 14.2466C14.6883 14.2466 18.5214 12.0102 20.6796 7.6938C20.8203 7.41227 20.8203 7.0809 20.6796 6.79937ZM10.7852 12.2466C7.81637 12.2466 4.78321 10.6258 2.91481 7.24658C4.78321 3.86736 7.81637 2.24658 10.7852 2.24658C13.7539 2.24658 16.7871 3.86736 18.6555 7.24658C16.7871 10.6258 13.7539 12.2466 10.7852 12.2466Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconEyeOff = () => (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.49226 0.539475C3.10174 0.148951 2.46857 0.148951 2.07805 0.539475C1.68753 0.93 1.68753 1.56316 2.07805 1.95369L4.50221 4.37785C3.07155 5.45396 1.82441 6.93201 0.890729 8.79937C0.749965 9.0809 0.749965 9.41227 0.890729 9.6938C3.04895 14.0102 6.88203 16.2466 10.7852 16.2466C12.3403 16.2466 13.8843 15.8916 15.3158 15.1914L18.0781 17.9537C18.4686 18.3442 19.1017 18.3442 19.4923 17.9537C19.8828 17.5632 19.8828 16.93 19.4923 16.5395L3.49226 0.539475ZM13.7989 13.6746C12.8194 14.0577 11.7985 14.2466 10.7852 14.2466C7.81637 14.2466 4.78321 12.6258 2.91481 9.24658C3.73237 7.76794 4.77293 6.62598 5.93354 5.80917L8.07753 7.95317C7.89011 8.34481 7.78516 8.78344 7.78516 9.24659C7.78516 10.9034 9.1283 12.2466 10.7852 12.2466C11.2483 12.2466 11.6869 12.1416 12.0786 11.9542L13.7989 13.6746Z"
      fill="#4A4A4A"
    />
    <path
      d="M17.3374 11.1421C17.8205 10.5867 18.2636 9.95534 18.6555 9.24658C16.7871 5.86736 13.7539 4.24658 10.7851 4.24658C10.6731 4.24658 10.561 4.24889 10.4489 4.25351L8.66455 2.46916C9.36257 2.32109 10.0727 2.24658 10.7851 2.24658C14.6882 2.24658 18.5213 4.48293 20.6795 8.79937C20.8203 9.0809 20.8203 9.41227 20.6795 9.6938C20.1356 10.7817 19.4852 11.7376 18.7541 12.5587L17.3374 11.1421Z"
      fill="#4A4A4A"
    />
  </svg>
);

export const IconSuccess = ({
  width = "25px",
  height = "25px",
  color = "#4A4A4A",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7852 4.24658C8.36688 4.24658 4.78516 7.8283 4.78516 12.2466C4.78516 16.6649 8.36688 20.2466 12.7852 20.2466C17.2034 20.2466 20.7852 16.6649 20.7852 12.2466C20.7852 7.8283 17.2034 4.24658 12.7852 4.24658ZM2.78516 12.2466C2.78516 6.72373 7.26231 2.24658 12.7852 2.24658C18.308 2.24658 22.7852 6.72373 22.7852 12.2466C22.7852 17.7694 18.308 22.2466 12.7852 22.2466C7.26231 22.2466 2.78516 17.7694 2.78516 12.2466ZM17.4495 8.99917C17.8623 9.36609 17.8995 9.99816 17.5326 10.4109L12.1992 16.4109C12.0095 16.6244 11.7375 16.7466 11.4518 16.7466C11.1662 16.7466 10.8942 16.6244 10.7044 16.4109L8.03775 13.4109C7.67083 12.9982 7.70801 12.3661 8.12079 11.9992C8.53358 11.6323 9.16565 11.6694 9.53257 12.0822L11.4518 14.2414L16.0377 9.08222C16.4047 8.66944 17.0367 8.63225 17.4495 8.99917Z"
      fill={color}
    />
  </svg>
);

export const IconCalendar = ({
  width = "25px",
  height = "25px",
  color = "#4A4A4A",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.78516 2.24658C10.3374 2.24658 10.7852 2.6943 10.7852 3.24658V4.24658H14.7852V3.24658C14.7852 2.6943 15.2329 2.24658 15.7852 2.24658C16.3374 2.24658 16.7852 2.6943 16.7852 3.24658V4.24658H19.7852C20.8897 4.24658 21.7852 5.14201 21.7852 6.24658V19.2466C21.7852 20.3512 20.8897 21.2466 19.7852 21.2466H5.78516C4.68059 21.2466 3.78516 20.3512 3.78516 19.2466V6.24658C3.78516 5.14201 4.68059 4.24658 5.78516 4.24658H8.78516V3.24658C8.78516 2.6943 9.23287 2.24658 9.78516 2.24658ZM8.78516 6.24658H5.78516V9.24658H19.7852V6.24658H16.7852V7.24658C16.7852 7.79887 16.3374 8.24658 15.7852 8.24658C15.2329 8.24658 14.7852 7.79887 14.7852 7.24658V6.24658H10.7852V7.24658C10.7852 7.79887 10.3374 8.24658 9.78516 8.24658C9.23287 8.24658 8.78516 7.79887 8.78516 7.24658V6.24658ZM19.7852 11.2466H5.78516V19.2466H19.7852V11.2466Z"
      fill={color}
    />
  </svg>
);

export const IconCircleError = ({
  width = "25px",
  height = "25px",
  color = "#4A4A4A",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7852 4.24658C8.36688 4.24658 4.78516 7.8283 4.78516 12.2466C4.78516 16.6649 8.36688 20.2466 12.7852 20.2466C17.2034 20.2466 20.7852 16.6649 20.7852 12.2466C20.7852 7.8283 17.2034 4.24658 12.7852 4.24658ZM2.78516 12.2466C2.78516 6.72373 7.26231 2.24658 12.7852 2.24658C18.308 2.24658 22.7852 6.72373 22.7852 12.2466C22.7852 17.7694 18.308 22.2466 12.7852 22.2466C7.26231 22.2466 2.78516 17.7694 2.78516 12.2466ZM8.57805 8.03948C8.96857 7.64895 9.60174 7.64895 9.99226 8.03948L12.7852 10.8324L15.578 8.03948C15.9686 7.64895 16.6017 7.64895 16.9923 8.03948C17.3828 8.43 17.3828 9.06316 16.9923 9.45369L14.1994 12.2466L16.9923 15.0395C17.3828 15.43 17.3828 16.0632 16.9923 16.4537C16.6017 16.8442 15.9686 16.8442 15.578 16.4537L12.7852 13.6608L9.99226 16.4537C9.60174 16.8442 8.96857 16.8442 8.57805 16.4537C8.18753 16.0632 8.18753 15.43 8.57805 15.0395L11.3709 12.2466L8.57805 9.45369C8.18753 9.06316 8.18753 8.43 8.57805 8.03948Z"
      fill={color}
    />
  </svg>
);

export const IconMenuVertical = ({
  width = "24px",
  height = "25px",
  color = "#4A4A4A",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.63599C10 4.24042 10.1173 3.85374 10.3371 3.52485C10.5568 3.19595 10.8692 2.9396 11.2346 2.78823C11.6001 2.63685 12.0022 2.59725 12.3902 2.67442C12.7781 2.75159 13.1345 2.94207 13.4142 3.22177C13.6939 3.50148 13.8844 3.85784 13.9616 4.24581C14.0387 4.63377 13.9991 5.0359 13.8478 5.40135C13.6964 5.76681 13.44 6.07916 13.1111 6.29893C12.7822 6.51869 12.3956 6.63599 12 6.63599C11.4696 6.63599 10.9609 6.42527 10.5858 6.0502C10.2107 5.67513 10 5.16642 10 4.63599ZM12 14.636C12.3956 14.636 12.7822 14.5187 13.1111 14.2989C13.44 14.0792 13.6964 13.7668 13.8478 13.4014C13.9991 13.0359 14.0387 12.6338 13.9616 12.2458C13.8844 11.8578 13.6939 11.5015 13.4142 11.2218C13.1345 10.9421 12.7781 10.7516 12.3902 10.6744C12.0022 10.5972 11.6001 10.6369 11.2346 10.7882C10.8692 10.9396 10.5568 11.1959 10.3371 11.5248C10.1173 11.8537 10 12.2404 10 12.636C10 13.1664 10.2107 13.6751 10.5858 14.0502C10.9609 14.4253 11.4696 14.636 12 14.636ZM12 22.636C12.3956 22.636 12.7822 22.5187 13.1111 22.2989C13.44 22.0792 13.6964 21.7668 13.8478 21.4014C13.9991 21.0359 14.0387 20.6338 13.9616 20.2458C13.8844 19.8578 13.6939 19.5015 13.4142 19.2218C13.1345 18.9421 12.7781 18.7516 12.3902 18.6744C12.0022 18.5972 11.6001 18.6369 11.2346 18.7882C10.8692 18.9396 10.5568 19.1959 10.3371 19.5248C10.1173 19.8537 10 20.2404 10 20.636C10 21.1664 10.2107 21.6751 10.5858 22.0502C10.9609 22.4253 11.4696 22.636 12 22.636Z"
      fill={color}
    />
  </svg>
);

export const IconCircleClose = ({
  width = "21.976",
  height = "21.976",
  color = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
  >
    <g id="iX" transform="translate(0 0)">
      <path
        id="Path_29"
        data-name="Path 29"
        d="M18.761,3.215a10.993,10.993,0,1,0,0,15.547A11.006,11.006,0,0,0,18.761,3.215ZM15.323,15.323a.845.845,0,0,1-1.2,0l-3.139-3.139L7.7,15.472a.845.845,0,0,1-1.2-1.2l3.289-3.289L6.653,7.848a.845.845,0,0,1,1.2-1.2l3.139,3.139,2.99-2.99a.845.845,0,0,1,1.2,1.2l-2.99,2.99,3.139,3.139A.845.845,0,0,1,15.323,15.323Z"
        transform="translate(0 0)"
        fill={color}
      />
    </g>
  </svg>
);

export const IconMenuSchedule = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.004"
    height="18.002"
    viewBox="0 0 23.004 18.002"
  >
    <path
      id="Union_88"
      data-name="Union 88"
      d="M-16970,12535a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-16970,12535Zm7.063,1a1.06,1.06,0,0,1-1.061-1.061,1.059,1.059,0,0,1,1.061-1.056h14.881a1.06,1.06,0,0,1,1.061,1.056,1.062,1.062,0,0,1-1.061,1.061Zm-7.062-8a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-16970,12528Zm7.063,1.057A1.059,1.059,0,0,1-16964,12528a1.06,1.06,0,0,1,1.061-1.061h14.881A1.062,1.062,0,0,1-16947,12528a1.061,1.061,0,0,1-1.061,1.057ZM-16970,12521a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-16970,12521Zm7.063,1.116a1.059,1.059,0,0,1-1.061-1.057,1.063,1.063,0,0,1,1.061-1.06h14.881a1.064,1.064,0,0,1,1.061,1.06,1.061,1.061,0,0,1-1.061,1.057Z"
      transform="translate(16970.002 -12518.999)"
      fill={color}
    />
  </svg>
);

export const IconCertificateBig = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="180.746"
    height="121.89"
    viewBox="0 0 180.746 121.89"
  >
    <g
      id="Group_83"
      data-name="Group 83"
      transform="translate(-543.627 -165.587)"
    >
      <rect
        id="Rectangle_4504"
        data-name="Rectangle 4504"
        width="172.049"
        height="107.303"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 543.627, 180.582)"
        fill="#f2f2f2"
      />
      <rect
        id="Rectangle_4514"
        data-name="Rectangle 4514"
        width="55.409"
        height="9.004"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 602.508, 194.582)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4515"
        data-name="Rectangle 4515"
        width="41.742"
        height="4.69"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 594.097, 220.347)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4518"
        data-name="Rectangle 4518"
        width="33.252"
        height="4.69"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 600.037, 230.87)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4519"
        data-name="Rectangle 4519"
        width="14.255"
        height="5.457"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 579.983, 267.682)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4520"
        data-name="Rectangle 4520"
        width="20.006"
        height="5.457"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 599.686, 265.958)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4516"
        data-name="Rectangle 4516"
        width="27.924"
        height="4.69"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 641.404, 216.208)"
        fill="#e3e3e3"
      />
      <rect
        id="Rectangle_4517"
        data-name="Rectangle 4517"
        width="24.233"
        height="4.69"
        transform="matrix(0.996, -0.087, 0.087, 0.996, 639.393, 227.426)"
        fill="#e3e3e3"
      />
      <path
        id="Path_271"
        data-name="Path 271"
        d="M-2455.582-1570.653l-7.1-88.487,151.9-12.225.027.35,4.089,53.587-.7.053-4.062-53.237-150.5,12.113,7.043,87.789Z"
        transform="translate(3015 1846)"
        fill="#d8d8d8"
      />
      <path
        id="Polygon_4"
        data-name="Polygon 4"
        d="M17.259,1.9a3,3,0,0,1,4.373,1.417l.1.256a3,3,0,0,0,2.547,1.865l.26.02a3,3,0,0,1,2.685,3.686l-.09.378a3,3,0,0,0,.955,2.963l.287.248a3,3,0,0,1,0,4.537l-.287.248a3,3,0,0,0-.955,2.963l.09.378a3,3,0,0,1-2.685,3.686l-.26.02a3,3,0,0,0-2.547,1.865l-.1.256A3,3,0,0,1,17.259,28.1l-.166-.1a3,3,0,0,0-3.185,0l-.166.1a3,3,0,0,1-4.373-1.417l-.1-.256a3,3,0,0,0-2.547-1.865l-.26-.02a3,3,0,0,1-2.685-3.686l.09-.378a3,3,0,0,0-.955-2.963l-.287-.248a3,3,0,0,1,0-4.537l.287-.248a3,3,0,0,0,.955-2.963l-.09-.378A3,3,0,0,1,6.457,5.457l.26-.02A3,3,0,0,0,9.265,3.571l.1-.256A3,3,0,0,1,13.741,1.9l.166.1a3,3,0,0,0,3.185,0Z"
        transform="translate(681.5 236.377)"
        fill="#ee312f"
      />
      <circle
        id="Ellipse_63"
        data-name="Ellipse 63"
        cx="6"
        cy="6"
        r="6"
        transform="translate(691 245)"
        fill="#d51a19"
      />
    </g>
  </svg>
);

export const EmailActivationImg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="187.214"
    height="86.38"
    viewBox="0 0 187.214 86.38"
  >
    <g
      id="Group_86"
      data-name="Group 86"
      transform="translate(-292.012 -182.017)"
    >
      <path
        id="Path_271"
        data-name="Path 271"
        d="M393.915,240.44h0v-.005c0-.026-.006-.052-.009-.077a1.36,1.36,0,0,0-.165.069c-4.117,2.158-8.184,4.5-12.46,6.306-10.581,4.766-25.553,7.664-35.649,1.482a32.132,32.132,0,0,0,4.943-9.621c1.656-5.365,1.577-13.2-3.637-16.743-4.972-3.379-10.081,1.045-11.465,5.954-1.887,6.69,1.4,13.685,6.214,18.251a25.584,25.584,0,0,0,2.724,2.249c-.646.831-1.312,1.624-1.988,2.366-7.12,7.8-16.9,12.309-27.073,14.6-7.687,1.732-15.5,2.111-23.337,2.571,2.892-.17,5.983.172,8.939.072a87.462,87.462,0,0,0,9.468-.818,63.236,63.236,0,0,0,17.961-5.191,51.645,51.645,0,0,0,6.743-3.813,42.871,42.871,0,0,0,10.051-9.276A46.2,46.2,0,0,0,349.8,251.2a26.086,26.086,0,0,0,5,1.366,34.39,34.39,0,0,0,10.514.038c7.255-1.013,14.091-3.775,20.622-6.982a52.082,52.082,0,0,0,7.507-4.846,3.9,3.9,0,0,1,.481-.293Zm-49.054,7.267a20.794,20.794,0,0,1-7.447-9.17c-1.592-3.655-2.151-8.06-.574-11.835,1.631-3.9,6.149-6.508,9.96-3.8,1.972,1.4,3.093,4.411,3.55,6.664C351.635,235.888,348.729,242.522,344.86,247.708Z"
        transform="translate(0 0.465)"
        fill="#1d1d1b"
      />
      <g
        id="Group_85"
        data-name="Group 85"
        transform="translate(381.728 182.017)"
      >
        <path
          id="Path_272"
          data-name="Path 272"
          d="M413.11,220.312q3.988,2.518,8.027,4.962a111.983,111.983,0,0,0-17.156,9.269A103.582,103.582,0,0,0,413.11,220.312Z"
          transform="translate(-380.38 -181.556)"
          fill="#e1f5f8"
        />
        <path
          id="Path_273"
          data-name="Path 273"
          d="M412.241,219.806a122.907,122.907,0,0,1-9.76,15.06,104.111,104.111,0,0,0-3.889-25.171c13-3.1,25.775-7.491,38.438-11.755,11.455-3.86,22.987-7.748,34.246-12.2-19.371,11.178-39.049,22.019-57.963,33.936A.672.672,0,0,0,412.241,219.806Z"
          transform="translate(-380.445 -181.972)"
          fill="#e2e2e2"
        />
        <path
          id="Path_274"
          data-name="Path 274"
          d="M437.559,196.73c-12.913,4.357-26.058,8.048-38.929,12.509a.2.2,0,0,0-.123.119.4.4,0,0,0-.138,0c-5.183-3.231-10.462-6.461-15.87-9.321,15.613-2.519,31.088-6.143,46.664-8.91q21.655-3.844,43.412-7C460.908,188.331,449.329,192.763,437.559,196.73Z"
          transform="translate(-380.639 -181.991)"
          fill="#f6f6f6"
        />
        <path
          id="Path_275"
          data-name="Path 275"
          d="M473.191,185.73q-20.406,21.6-38.844,44.939a.668.668,0,0,0,.081.935c-.139.174-.277.348-.41.53a173.56,173.56,0,0,0-20.253-12.045C433.905,209.3,453.467,197.269,473.191,185.73Z"
          transform="translate(-380.263 -181.972)"
          fill="#f6f6f6"
        />
        <path
          id="Path_276"
          data-name="Path 276"
          d="M421.418,225.735q-4.034-2.452-8.027-4.962A103.581,103.581,0,0,1,404.262,235,111.983,111.983,0,0,1,421.418,225.735Zm-8.961-5.884a.672.672,0,0,1,1.072-.134c18.914-11.917,38.592-22.758,57.963-33.936-11.259,4.455-22.791,8.343-34.246,12.2-12.664,4.264-25.435,8.658-38.438,11.755a104.114,104.114,0,0,1,3.889,25.171A122.9,122.9,0,0,0,412.457,219.851Zm-29.936-19.784c5.407,2.86,10.687,6.089,15.87,9.321a.394.394,0,0,1,.138,0,.2.2,0,0,1,.123-.119c12.871-4.461,26.016-8.152,38.929-12.509,11.77-3.967,23.35-8.4,35.016-12.6q-21.752,3.185-43.412,7C413.609,193.924,398.134,197.548,382.521,200.067Zm91.068-14.292c-19.724,11.539-39.285,23.57-59.426,34.36a173.56,173.56,0,0,1,20.253,12.045c.133-.182.271-.356.41-.53a.668.668,0,0,1-.081-.935Q453.161,207.38,473.589,185.775Zm-92.308,13.64c15.371-4.125,31.318-6.667,46.974-9.472q24.479-4.387,49.1-7.92A.717.717,0,0,1,478,183.17q-22.022,23.009-41.789,48.011a2.642,2.642,0,0,1-1.218,1.957.741.741,0,0,1-1.071.344c-3.719-2.392-7.494-4.688-11.267-6.991a224.251,224.251,0,0,0-19.957,10.54.8.8,0,0,0-.06.072.65.65,0,0,1-1.141-.33,171.469,171.469,0,0,0-3.2-26.324.379.379,0,0,1-.2-.055c-5.6-3.2-11.263-6.522-16.6-10.156-.133.021-.257.044-.381.058a.414.414,0,0,1-.279-.745.274.274,0,0,1,.374-.18A.334.334,0,0,0,381.281,199.415Z"
          transform="translate(-380.661 -182.017)"
          fill="#1d1d1b"
        />
      </g>
      <path
        id="Path_277"
        data-name="Path 277"
        d="M428.137,185.979c-14.323,1.672-28.674,3.947-42.893,6.322-.157.026-.107.255.048.237,14.324-1.712,28.744-3.555,42.964-5.972C428.643,186.5,428.522,185.934,428.137,185.979Z"
        transform="translate(1.121 0.048)"
        fill="#1d1d1b"
      />
      <path
        id="Path_278"
        data-name="Path 278"
        d="M448.627,222.475a3.171,3.171,0,0,0-.223-.392c-.033-.036-.068-.073-.1-.107l-.026-.015h-.056c-.02.005-.041.007-.061.013a1.386,1.386,0,0,1-.367.05c-4.46,6.253-8.843,12.564-13.174,18.874-.089.131.109.254.2.13,4.64-6.128,9.265-12.306,13.81-18.539Z"
        transform="translate(1.716 0.481)"
        fill="#1d1d1b"
      />
    </g>
  </svg>
);

export const IconCongrats = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="336.699"
    height="255.379"
    viewBox="0 0 336.699 255.379"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Path_250"
          data-name="Path 250"
          d="M353.374,503.286l-7.5-10.382s.527-5.6,1.6-11.725-17.44-46.219-17.44-46.219-8.87-1.03-7.834,8.761,4.2,28.334,4.2,28.334l-50.946-46.221a4.768,4.768,0,0,0-6.011.815c-2.137,1.965-1.533,3.442-.11,6.8,0,0-6.981-9.835-10.65-7.724s-4.723,4.624-1.371,9.353c0,0-2.277-2.156-5.287,1.327s.308,8.006,2.937,12.222c0,0-2.373-2.34-6.282,1.709-5.27,5.46,11.484,43.632,55.32,65.62l17.552,14.6Z"
          transform="translate(-247.751 -425.123)"
          fill="#ea9a8d"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          id="Path_258"
          data-name="Path 258"
          d="M310.337,540.669,306.3,528.514s2.185-5.186,5.049-10.7-2.759-49.323-2.759-49.323-8.153-3.646-10.1,6-4.5,28.29-4.5,28.29L259.272,443.4a4.767,4.767,0,0,0-5.978-1.027c-2.63,1.233-2.5,2.824-2.148,6.458,0,0-3.707-11.477-7.84-10.565s-5.893,2.993-4.115,8.51c0,0-1.525-2.74-5.442-.322s-2.11,7.729-.868,12.54c0,0-1.561-2.945-6.505-.255-6.666,3.625-2.145,45.066,33.068,79.2l12.358,19.2Z"
          transform="translate(-223.777 -438.213)"
          fill="#eeaca2"
        />
      </clipPath>
    </defs>
    <g
      id="Group_82"
      data-name="Group 82"
      transform="translate(-436.315 -28.621)"
    >
      <g
        id="Group_81"
        data-name="Group 81"
        transform="translate(336.223 -303.124)"
      >
        <g
          id="Group_77"
          data-name="Group 77"
          transform="translate(245.937 425.123)"
        >
          <path
            id="Path_248"
            data-name="Path 248"
            d="M353.374,503.286l-7.5-10.382s.527-5.6,1.6-11.725-17.44-46.219-17.44-46.219-8.87-1.03-7.834,8.761,4.2,28.334,4.2,28.334l-50.946-46.221a4.768,4.768,0,0,0-6.011.815c-2.137,1.965-1.533,3.442-.11,6.8,0,0-6.981-9.835-10.65-7.724s-4.723,4.624-1.371,9.353c0,0-2.277-2.156-5.287,1.327s.308,8.006,2.937,12.222c0,0-2.373-2.34-6.282,1.709-5.27,5.46,11.484,43.632,55.32,65.62l17.552,14.6Z"
            transform="translate(-247.751 -425.123)"
            fill="#ea9a8d"
          />
          <g id="Group_76" data-name="Group 76" clip-path="url(#clip-path)">
            <path
              id="Path_249"
              data-name="Path 249"
              d="M337.008,434.673s-3.6,2.132-2.683,4.5a33.317,33.317,0,0,0,2.788,5.185l3.556-1.381-3.115-7.72"
              transform="translate(-254.291 -425.846)"
              fill="#fff"
            />
          </g>
        </g>
        <path
          id="Path_251"
          data-name="Path 251"
          d="M358.76,498.36l-40.222,38.889,40.75,55.417h84.674Z"
          transform="translate(-7.171 -5.542)"
          fill="#73379b"
        />
        <g
          id="Group_80"
          data-name="Group 80"
          transform="translate(223.777 437.223)"
        >
          <path
            id="Path_252"
            data-name="Path 252"
            d="M310.337,540.669,306.3,528.514s2.185-5.186,5.049-10.7-2.759-49.323-2.759-49.323-8.153-3.646-10.1,6-4.5,28.29-4.5,28.29L259.272,443.4a4.767,4.767,0,0,0-5.978-1.027c-2.63,1.233-2.5,2.824-2.148,6.458,0,0-3.707-11.477-7.84-10.565s-5.893,2.993-4.115,8.51c0,0-1.525-2.74-5.442-.322s-2.11,7.729-.868,12.54c0,0-1.561-2.945-6.505-.255-6.666,3.625-2.145,45.066,33.068,79.2l12.358,19.2Z"
            transform="translate(-223.777 -438.213)"
            fill="#eeaca2"
          />
          <g id="Group_79" data-name="Group 79" clip-path="url(#clip-path-2)">
            <g
              id="Group_78"
              data-name="Group 78"
              transform="translate(2.279 2.146)"
            >
              <path
                id="Path_253"
                data-name="Path 253"
                d="M255.807,446.494l3.861-2s3.934,5.178,1.4,6.732S255.807,446.494,255.807,446.494Z"
                transform="translate(-228.479 -440.834)"
                fill="#fff"
              />
              <path
                id="Path_254"
                data-name="Path 254"
                d="M315.694,470.624s-3.663.555-3.588,3.1a33.277,33.277,0,0,0,.894,5.819l3.813-.112-1.025-7.946"
                transform="translate(-232.74 -442.812)"
                fill="#fff"
              />
              <path
                id="Path_255"
                data-name="Path 255"
                d="M242.624,442.539l3.86-2s3.935,5.178,1.4,6.731S242.624,442.539,242.624,442.539Z"
                transform="translate(-227.482 -440.535)"
                fill="#fff"
              />
              <path
                id="Path_256"
                data-name="Path 256"
                d="M234.423,450.778l3.861-2s3.934,5.179,1.4,6.732S234.423,450.778,234.423,450.778Z"
                transform="translate(-226.861 -441.158)"
                fill="#fff"
              />
              <path
                id="Path_257"
                data-name="Path 257"
                d="M226.242,464.725l3.86-2s3.935,5.179,1.4,6.732S226.242,464.725,226.242,464.725Z"
                transform="translate(-226.242 -442.214)"
                fill="#fff"
              />
              <line
                id="Line_35"
                data-name="Line 35"
                x2="8.902"
                y2="24.423"
                transform="translate(4.469 13.57)"
                fill="none"
                stroke="#e27361"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
              />
              <line
                id="Line_36"
                data-name="Line 36"
                x2="12.68"
                y2="30.741"
                transform="translate(10.915 0.862)"
                fill="none"
                stroke="#e27361"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
              />
              <line
                id="Line_37"
                data-name="Line 37"
                x2="10.873"
                y2="27.751"
                transform="translate(23.995 4.843)"
                fill="none"
                stroke="#e27361"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0.5"
              />
            </g>
          </g>
        </g>
        <path
          id="Path_259"
          data-name="Path 259"
          d="M318.619,539.5l-50.869,23.29,10.019,32.988h64.349Z"
          transform="translate(-3.328 -8.656)"
          fill="#8348aa"
        />
      </g>
      <path
        id="Path_260"
        data-name="Path 260"
        d="M-4821.695-1688.139a.251.251,0,0,1-.187-.084l-19.638-22.226a.25.25,0,0,1,.022-.353.25.25,0,0,1,.353.022l19.638,22.226a.25.25,0,0,1-.022.353A.249.249,0,0,1-4821.695-1688.139Z"
        transform="translate(5445 1841)"
        fill="#cc6c5d"
      />
      <path
        id="Path_261"
        data-name="Path 261"
        d="M-4816.552-1680.317a.249.249,0,0,1-.193-.091l-24.782-30.048a.25.25,0,0,1,.034-.352.25.25,0,0,1,.352.034l24.782,30.048a.25.25,0,0,1-.034.352A.25.25,0,0,1-4816.552-1680.317Z"
        transform="translate(5433 1843)"
        fill="#cc6c5d"
      />
      <path
        id="Path_260-2"
        data-name="Path 260"
        d="M-4858.177-1748.438a.5.5,0,0,1-.482-.371l-8.278-31.065a.5.5,0,0,1,.354-.612.5.5,0,0,1,.612.354l8.278,31.065a.5.5,0,0,1-.354.612A.5.5,0,0,1-4858.177-1748.438Z"
        transform="translate(5442 1857.003)"
        fill="#707070"
      />
      <path
        id="Path_262"
        data-name="Path 262"
        d="M-4843.081-1759.914a.5.5,0,0,1-.321-.117l-23.374-19.588a.5.5,0,0,1-.062-.7.5.5,0,0,1,.7-.062l23.374,19.588a.5.5,0,0,1,.062.7A.5.5,0,0,1-4843.081-1759.914Z"
        transform="translate(5570.224 1285.707) rotate(-7)"
        fill="#707070"
      />
      <path
        id="Path_263"
        data-name="Path 263"
        d="M-4842.83-1770.634a.5.5,0,0,1-.176-.032l-23.624-8.869a.5.5,0,0,1-.292-.644.5.5,0,0,1,.644-.292l23.624,8.869a.5.5,0,0,1,.292.644A.5.5,0,0,1-4842.83-1770.634Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 5614.763, 1065.711)"
        fill="#707070"
      />
      <path
        id="Path_261-2"
        data-name="Path 261"
        d="M-4876.026-1749.046a.5.5,0,0,1-.15-.023.5.5,0,0,1-.327-.627l9.572-30.456a.5.5,0,0,1,.627-.327.5.5,0,0,1,.327.627l-9.572,30.456A.5.5,0,0,1-4876.026-1749.046Z"
        transform="translate(5498.278 1857.938)"
        fill="#707070"
      />
      <path
        id="Path_269"
        data-name="Path 269"
        d="M0,0H7L3.811,6.976,0,9Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 703.113, 109.28)"
        fill="#6b8ff2"
      />
      <rect
        id="Rectangle_4512"
        data-name="Rectangle 4512"
        width="3.042"
        height="7.099"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 489.771, 74.111)"
        fill="#60d098"
      />
      <rect
        id="Rectangle_4513"
        data-name="Rectangle 4513"
        width="6.261"
        height="9"
        transform="translate(483.236 116.787) rotate(14)"
        fill="#f2e26b"
      />
      <path
        id="Path_266"
        data-name="Path 266"
        d="M0,0H7V9Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 436.315, 144.836)"
        fill="#6b8ff2"
      />
      <path
        id="Path_267"
        data-name="Path 267"
        d="M0,0H7L4.066,6.627,0,9Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 494, 178.836)"
        fill="#d0390c"
      />
      <path
        id="Path_265"
        data-name="Path 265"
        d="M0,0H7L5.7,7.039,0,9Z"
        transform="translate(553.927 43.266) rotate(19)"
        fill="#6b8ff2"
      />
      <path
        id="Path_264"
        data-name="Path 264"
        d="M0,0H7V9L1.661,5.977Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 622.252, 29.836)"
        fill="#f2e26b"
      />
      <path
        id="Path_270"
        data-name="Path 270"
        d="M.862,4.11,7,0V9H0Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 707.342, 49.876)"
        fill="#d0390c"
      />
      <path
        id="Path_268"
        data-name="Path 268"
        d="M0,0H7V9Z"
        transform="matrix(0.875, 0.485, -0.485, 0.875, 665.628, 71.367)"
        fill="#60d098"
      />
      <path
        id="Polygon_2"
        data-name="Polygon 2"
        d="M5.848,0,7.31,3.777l4.386.1L8.213,6.316l1.249,3.84L5.848,7.885,2.234,10.156l1.249-3.84L0,3.879l4.386-.1Z"
        transform="translate(507.635 47.484) rotate(-11)"
        fill="#f2c36b"
      />
      <path
        id="Polygon_3"
        data-name="Polygon 3"
        d="M5.848,0,7.31,3.777l4.386.1L8.213,6.316l1.249,3.84L5.848,7.885,2.234,10.156l1.249-3.84L0,3.879l4.386-.1Z"
        transform="translate(667.643 35.993) rotate(17)"
        fill="#f2c36b"
      />
    </g>
  </svg>
);

export const WellmsLogo = ({ width = "100px", height = "30px" }) => {
  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      id="Warstwa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 632.3 171.9"
    >
      <style type="text/css">
        {`
          	.st0{fill:#FFFFFF;}
            .st1{fill:#0000D9;}

        `}
      </style>
      <g>
        <g>
          <path
            d="M248.5,128.9l-22.9-60.1h12.8l16.1,45.6l16.6-45.6h9.6l16.4,45.8l16.4-45.8h12.2l-22.9,60.1h-11.3l-15.9-43l-15.8,43
        H248.5z"
          />
          <path
            className="st0"
            d="M325.7,68.8l-22.9,60.1h-11.3l-15.9-43l-15.8,43h-11.3l-22.9-60.1h12.8l16.1,45.6l16.6-45.6h9.6l16.4,45.8
        l16.4-45.8H325.7 M325.7,65.8h-12.2c-1.3,0-2.4,0.8-2.8,2l-13.6,37.9l-13.6-37.9c-0.4-1.2-1.6-2-2.8-2h-9.6c-1.3,0-2.4,0.8-2.8,2
        l-13.8,37.7l-13.3-37.7c-0.4-1.2-1.6-2-2.8-2h-12.8c-1,0-1.9,0.5-2.5,1.3c-0.6,0.8-0.7,1.8-0.3,2.8l22.9,60.1
        c0.4,1.2,1.6,1.9,2.8,1.9h11.3c1.3,0,2.4-0.8,2.8-2l13-35.3l13.1,35.3c0.4,1.2,1.6,2,2.8,2h11.3c1.2,0,2.4-0.8,2.8-1.9l22.9-60.1
        c0.4-0.9,0.2-2-0.3-2.8C327.6,66.2,326.7,65.8,325.7,65.8L325.7,65.8z"
          />
        </g>
        <g>
          <path
            d="M363.5,130c-9.9,0-17.6-2.8-23.3-8.3s-8.5-13.1-8.5-22.7c0-6.2,1.2-11.6,3.8-16.3c2.5-4.7,6-8.4,10.4-11
        c4.4-2.6,9.5-3.9,15.3-3.9c8.3,0,14.8,2.6,19.6,7.9c4.8,5.3,7.1,12.6,7.1,21.9v4.2h-44.1c0.9,12.5,7.5,18.7,19.8,18.7
        c3.5,0,6.8-0.5,10.2-1.6c3.3-1.1,6.5-2.8,9.4-5.3l3.7,8.6c-2.7,2.5-6.2,4.4-10.5,5.8C372.2,129.3,367.9,130,363.5,130z
         M361.7,76.4c-5.2,0-9.3,1.6-12.3,4.8c-3,3.2-4.9,7.5-5.5,12.8h33.6c-0.2-5.6-1.7-9.9-4.4-13S366.5,76.4,361.7,76.4z"
          />
          <path
            className="st0"
            d="M361.2,67.7c8.3,0,14.8,2.7,19.6,7.9c4.8,5.3,7.1,12.6,7.1,21.9v4.2h-44.1c0.9,12.5,7.5,18.7,19.8,18.7
        c3.5,0,6.8-0.5,10.2-1.6c3.3-1.1,6.5-2.8,9.4-5.3l3.7,8.6c-2.7,2.5-6.2,4.4-10.5,5.8c-4.3,1.4-8.6,2.1-12.9,2.1
        c-9.9,0-17.6-2.8-23.3-8.3c-5.7-5.5-8.5-13.1-8.5-22.7c0-6.2,1.2-11.6,3.8-16.3c2.5-4.7,6-8.4,10.4-11
        C350.3,69,355.4,67.7,361.2,67.7 M343.8,94h33.6c-0.2-5.6-1.7-9.9-4.4-13c-2.7-3.1-6.5-4.6-11.3-4.6c-5.2,0-9.3,1.6-12.3,4.8
        C346.3,84.4,344.5,88.7,343.8,94 M361.2,64.7c-6.3,0-11.9,1.5-16.8,4.4c-4.9,2.9-8.8,7-11.5,12.2c-2.7,5.1-4.1,11.1-4.1,17.7
        c0,10.4,3.2,18.8,9.4,24.9c6.2,6.1,14.8,9.2,25.4,9.2c4.6,0,9.3-0.8,13.9-2.2c4.7-1.5,8.5-3.7,11.6-6.4c0.9-0.9,1.2-2.2,0.7-3.4
        l-3.7-8.6c-0.4-0.9-1.1-1.5-2.1-1.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.7,0-1.4,0.2-1.9,0.7c-2.6,2.2-5.5,3.8-8.4,4.7
        c-3,1-6.1,1.5-9.2,1.5c-9.6,0-14.9-4.1-16.4-12.7h40.7c1.7,0,3-1.3,3-3v-4.2c0-10-2.7-18-7.9-23.9
        C377.7,67.7,370.3,64.7,361.2,64.7L361.2,64.7z M347.4,91c0.8-3.1,2.2-5.7,4.1-7.7c2.5-2.6,5.8-3.9,10.1-3.9c4,0,6.9,1.2,9.1,3.6
        c1.7,2,2.9,4.6,3.4,8H347.4L347.4,91z"
          />
        </g>
        <g>
          <path
            d="M421,130c-6.6,0-11.5-1.9-14.7-5.5s-4.9-9.1-4.9-16.3V42h12.4v65.4c0,8.1,3.3,12.2,10,12.2c1,0,1.9,0,2.8-0.1
        c0.9-0.1,1.7-0.2,2.7-0.5l-0.2,10C426.2,129.6,423.6,130,421,130z"
          />
          <path
            className="st0"
            d="M413.9,42v65.4c0,8.1,3.3,12.2,10,12.2c1,0,1.9,0,2.8-0.1c0.9-0.1,1.7-0.2,2.7-0.5l-0.2,10
        c-2.8,0.6-5.5,1-8,1c-6.6,0-11.5-1.8-14.7-5.5s-4.9-9.1-4.9-16.3V42H413.9 M413.9,39h-12.4c-1.7,0-3,1.3-3,3v66.1
        c0,7.9,1.9,14,5.6,18.2c3.8,4.4,9.5,6.6,17,6.6c2.7,0,5.7-0.4,8.7-1.1c1.3-0.3,2.3-1.5,2.3-2.8l0.2-10c0-0.9-0.4-1.8-1.1-2.4
        c-0.5-0.4-1.2-0.6-1.9-0.6c-0.3,0-0.5,0-0.8,0.1c-0.8,0.2-1.5,0.3-2.2,0.4c-0.8,0.1-1.6,0.1-2.5,0.1c-3.5,0-7-1.1-7-9.2V42
        C416.9,40.4,415.6,39,413.9,39L413.9,39z"
          />
        </g>
        <g>
          <path
            d="M458.7,130c-6.6,0-11.5-1.9-14.7-5.5s-4.9-9.1-4.9-16.3V42h12.4v65.4c0,8.1,3.3,12.2,10,12.2c1,0,1.9,0,2.8-0.1
        c0.9-0.1,1.7-0.2,2.7-0.5l-0.2,10C463.9,129.6,461.3,130,458.7,130z"
          />
          <path
            className="st0"
            d="M451.6,42v65.4c0,8.1,3.3,12.2,10,12.2c1,0,1.9,0,2.8-0.1c0.9-0.1,1.7-0.2,2.7-0.5l-0.2,10
        c-2.8,0.6-5.5,1-8,1c-6.6,0-11.5-1.8-14.7-5.5s-4.9-9.1-4.9-16.3V42H451.6 M451.6,39h-12.4c-1.7,0-3,1.3-3,3v66.1
        c0,7.9,1.9,14,5.6,18.2c3.8,4.4,9.5,6.6,17,6.6c2.8,0,5.7-0.4,8.7-1.1c1.3-0.3,2.3-1.5,2.3-2.8l0.2-10c0-0.9-0.4-1.8-1.1-2.4
        c-0.5-0.4-1.2-0.6-1.9-0.6c-0.3,0-0.5,0-0.8,0.1c-0.8,0.2-1.5,0.3-2.2,0.4c-0.8,0.1-1.6,0.1-2.5,0.1c-3.5,0-7-1.1-7-9.2V42
        C454.6,40.4,453.2,39,451.6,39L451.6,39z"
          />
        </g>
        <g>
          <path
            d="M477.1,128.9V68.8h12.1v9.7c1.8-3.5,4.3-6.1,7.5-8s6.9-2.8,11.2-2.8c9.2,0,15.1,4,17.9,12.1c1.9-3.8,4.6-6.7,8.1-8.9
        c3.5-2.1,7.5-3.2,12.1-3.2c13.5,0,20.2,8,20.2,24.1v37.1h-12.4V92.4c0-5.1-0.9-8.8-2.7-11.2s-4.7-3.6-8.7-3.6
        c-4.5,0-8.1,1.6-10.7,4.7c-2.6,3.2-3.9,7.5-3.9,12.9v33.6h-12.4V92.4c0-5.1-0.9-8.8-2.6-11.2c-1.7-2.4-4.6-3.6-8.6-3.6
        c-4.5,0-8.1,1.6-10.7,4.7c-2.6,3.2-3.9,7.5-3.9,12.9v33.6L477.1,128.9L477.1,128.9z"
          />
          <path
            className="st0"
            d="M545.9,67.6c13.5,0,20.2,8.1,20.2,24.1v37.1h-12.4V92.4c0-5.1-0.9-8.8-2.7-11.2c-1.8-2.4-4.7-3.6-8.7-3.6
        c-4.5,0-8.1,1.6-10.7,4.7c-2.6,3.2-3.9,7.4-3.9,12.9v33.6h-12.4V92.4c0-5.1-0.9-8.8-2.6-11.2c-1.7-2.4-4.6-3.6-8.6-3.6
        c-4.5,0-8.1,1.6-10.7,4.7c-2.6,3.2-3.9,7.5-3.9,12.9v33.6h-12.4V68.8h12.1v9.7c1.8-3.5,4.3-6.1,7.5-8c3.2-1.9,6.9-2.8,11.2-2.8
        c9.2,0,15.1,4,17.9,12.1c1.9-3.8,4.6-6.7,8.1-8.9C537.4,68.7,541.4,67.6,545.9,67.6 M477.1,128.8L477.1,128.8L477.1,128.8
         M545.9,64.6c-5,0-9.6,1.2-13.6,3.6c-2.4,1.4-4.4,3.2-6.2,5.3c-3.8-5.9-10-9-18.3-9c-4.8,0-9.1,1.1-12.7,3.2
        c-1.1,0.6-2.1,1.3-3,2.1v-1.2c0-1.7-1.3-3-3-3h-12.1c-1.7,0-3,1.3-3,3v60.1v0c0,1.7,1.3,3,3,3c0.1,0,0.2,0,0.3,0h12.1
        c1.7,0,3-1.3,3-3V95.2c0-4.7,1.1-8.4,3.2-11c2-2.5,4.7-3.6,8.3-3.6c3,0,5.1,0.8,6.2,2.3c1.3,1.8,2,5.1,2,9.5v36.5c0,1.7,1.3,3,3,3
        h12.4c1.7,0,3-1.3,3-3V95.2c0-4.7,1.1-8.4,3.2-11c2-2.5,4.8-3.7,8.4-3.7c3,0,5.1,0.8,6.3,2.4c1.3,1.8,2.1,5.1,2.1,9.4v36.5
        c0,1.7,1.3,3,3,3h12.4c1.7,0,3-1.3,3-3V91.8C569.1,69.4,556.5,64.6,545.9,64.6L545.9,64.6z"
          />
        </g>
        <g>
          <path
            d="M604.5,130c-4.9,0-9.5-0.6-13.8-1.9c-4.3-1.3-7.8-3.1-10.7-5.4l3.6-8.4c3,2.1,6.4,3.8,10,4.9c3.7,1.1,7.3,1.7,11,1.7
        c4.3,0,7.6-0.8,9.8-2.3c2.2-1.6,3.3-3.6,3.3-6.3c0-2.1-0.7-3.8-2.2-5s-3.7-2.1-6.7-2.8l-11.7-2.3c-10.3-2.1-15.5-7.5-15.5-16
        c0-5.7,2.3-10.2,6.8-13.5s10.4-5,17.7-5c4.2,0,8.2,0.6,12,1.9s7,3.1,9.5,5.5l-3.6,8.4c-2.5-2.1-5.3-3.8-8.5-4.9s-6.4-1.7-9.5-1.7
        c-4.3,0-7.5,0.8-9.7,2.4s-3.3,3.8-3.3,6.5c0,4.1,2.7,6.7,8.1,7.9l11.7,2.3c5.3,1.1,9.4,2.9,12.1,5.4c2.8,2.5,4.1,6,4.1,10.4
        c0,5.8-2.3,10.2-6.8,13.5C618,128.3,612,130,604.5,130z"
          />
          <path
            className="st0"
            d="M606.3,67.6c4.2,0,8.2,0.6,12,1.9c3.8,1.2,7,3.1,9.6,5.5l-3.6,8.4c-2.5-2.1-5.3-3.8-8.5-4.9
        c-3.2-1.1-6.4-1.7-9.5-1.7c-4.3,0-7.5,0.8-9.7,2.4c-2.2,1.6-3.3,3.8-3.3,6.5c0,4.1,2.7,6.7,8.1,7.9l11.7,2.3
        c5.3,1.1,9.4,2.9,12.1,5.4c2.8,2.5,4.1,6,4.1,10.3c0,5.8-2.3,10.2-6.8,13.5c-4.5,3.2-10.5,4.9-18,4.9c-4.9,0-9.5-0.6-13.8-1.9
        c-4.3-1.3-7.8-3.1-10.7-5.4l3.6-8.4c3,2.1,6.4,3.8,10,4.9c3.7,1.2,7.3,1.7,11,1.7c4.3,0,7.6-0.8,9.8-2.3c2.2-1.6,3.3-3.7,3.3-6.3
        c0-2.1-0.7-3.8-2.2-5c-1.5-1.2-3.7-2.1-6.7-2.8l-11.7-2.3c-10.3-2.1-15.5-7.5-15.5-16c0-5.7,2.3-10.2,6.8-13.5
        C593,69.3,599,67.6,606.3,67.6 M606.3,64.6c-7.9,0-14.5,1.9-19.5,5.6c-5.3,4-8,9.3-8,16c0,7,3.1,15.9,17.9,18.9l11.7,2.3
        c3.1,0.7,4.6,1.6,5.4,2.2c0.5,0.4,1.1,1.1,1.1,2.7c0,1.6-0.6,2.8-2.1,3.8c-1.7,1.2-4.5,1.8-8.1,1.8c-3.4,0-6.8-0.5-10.1-1.6
        c-3.3-1.1-6.4-2.6-9.2-4.5c-0.5-0.4-1.1-0.5-1.7-0.5c-0.3,0-0.6,0-0.8,0.1c-0.9,0.2-1.6,0.9-1.9,1.7l-3.6,8.4
        c-0.5,1.2-0.2,2.7,0.9,3.5c3.2,2.5,7.1,4.5,11.7,5.9c4.5,1.3,9.5,2,14.6,2c8.1,0,14.7-1.8,19.7-5.4c5.3-3.8,8-9.2,8-15.9
        c0-5.2-1.7-9.4-5.1-12.5c-3.2-2.9-7.7-5-13.6-6.2l-11.7-2.3c-5.7-1.2-5.7-3.8-5.7-4.9c0-1.8,0.6-3,2.1-4c1.7-1.2,4.4-1.8,8-1.8
        c2.8,0,5.6,0.5,8.5,1.5c2.8,1,5.4,2.5,7.6,4.4c0.6,0.5,1.2,0.7,2,0.7c0.2,0,0.5,0,0.7-0.1c0.9-0.2,1.7-0.9,2.1-1.7l3.6-8.4
        c0.5-1.1,0.2-2.5-0.7-3.3c-2.9-2.8-6.5-4.9-10.7-6.2C615.1,65.3,610.7,64.6,606.3,64.6L606.3,64.6z"
          />
        </g>
      </g>
      <path
        className="st1"
        d="M167.4,77.6c1.3-6.1,2.3-12.2,3.2-18.4c0.8-6.2,1.5-12.5,1.5-19c0,0,0,0,0,0c0-4.1-0.3-8.3-1.1-12.5
    c-0.1-0.5-0.2-1.1-0.3-1.6c-0.1-0.5-0.2-1.1-0.4-1.6c-0.3-1.1-0.6-2.1-0.9-3.1c-0.7-2.1-1.6-4.2-2.7-6.2c-2.2-4-5.4-7.8-9.3-10.5
    c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.3-0.2-0.5-0.3-0.8-0.5c-0.5-0.3-1-0.6-1.6-0.9c-1.1-0.5-2.2-1-3.3-1.4
    c-1.1-0.4-2.3-0.7-3.5-1c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.1c-0.3,0-0.6-0.1-1-0.1c-0.2,0-0.3,0-0.5,0
    c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0h0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0
    c-0.2,0-0.4,0-0.5,0c-0.3,0-0.6,0.1-1,0.1s-0.6,0.1-0.9,0.1c-0.3,0.1-0.6,0.1-0.9,0.2c-1.2,0.2-2.4,0.6-3.5,1
    c-1.1,0.4-2.2,0.9-3.3,1.4c-0.5,0.3-1.1,0.6-1.6,0.9c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.2-0.4,0.3
    c-4,2.7-7.2,6.4-9.3,10.5c-1.1,2-2,4.1-2.7,6.2c-0.4,1-0.6,2.1-0.9,3.1c-0.2,0.5-0.3,1.1-0.4,1.6s-0.2,1.1-0.3,1.6
    c-0.8,4.2-1.1,8.4-1.1,12.5c0,0,0,0,0,0c0,5,0.8,9.7,1.9,14.2c1.1,4.5,2.6,8.8,4.2,13c3.3,8.4,7.2,16.4,11.5,24
    c4.1,7.4,8.6,14.5,13.2,21.5c-1.6,4.5-3.4,9-5.4,13.4c-2.4,5.4-5.1,10.6-8.1,15.5c-1.5,2.4-3.1,4.8-4.9,7c-1.7,2.2-3.6,4.2-5.5,5.9
    c-0.5,0.4-1,0.9-1.5,1.2c-0.2,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.5,0.4-0.8,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.2
    c-0.3,0.2-0.5,0.3-0.8,0.5c-0.3,0.1-0.5,0.3-0.8,0.4c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.3,0.1-0.5,0.2-0.8,0.4
    c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.5,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0.1-0.5,0.1-0.8,0.2
    c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5,0-0.8,0l0,0c-3.4,0-6.7-0.7-9.7-2.1
    c-1.8-0.8-3.5-1.9-5.1-3.1c1.4-1.9,2.8-3.8,4-5.8c2.4-3.9,4.4-7.9,6.1-12c3.4-8.2,5.9-16.6,7.6-25.1c0.9-4.3,1.6-8.6,2.1-12.9
    c0.5-4.3,0.9-8.7,0.9-13.2c0,0,0,0,0,0c0-3.5-0.5-7.2-1.8-10.9c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.5-0.3-0.7
    c-0.2-0.5-0.4-0.9-0.6-1.3c-0.2-0.4-0.4-0.9-0.7-1.3c-0.3-0.4-0.5-0.8-0.8-1.3c-1.1-1.7-2.4-3.2-3.8-4.6c-2.9-2.7-6.3-4.6-9.7-5.9
    c-1.7-0.6-3.5-1.1-5.2-1.5c-0.9-0.2-1.8-0.3-2.7-0.4c-0.4,0-0.9-0.1-1.4-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.4,0
    c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0s0,0,0,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0
    c-0.2,0-0.5,0-0.7,0c-0.5,0-0.9,0.1-1.4,0.1c-0.9,0.1-1.8,0.3-2.7,0.4c-1.8,0.4-3.5,0.8-5.2,1.5c-3.4,1.3-6.8,3.2-9.7,5.9
    c-1.4,1.4-2.7,2.9-3.8,4.6c-0.3,0.4-0.5,0.8-0.8,1.3c-0.2,0.4-0.4,0.9-0.7,1.3c-0.2,0.4-0.4,0.9-0.6,1.3c-0.1,0.2-0.2,0.5-0.3,0.7
    s-0.2,0.5-0.3,0.7c-1.3,3.6-1.8,7.4-1.8,10.9c0,0,0,0,0,0c0,4.5,0.4,8.9,0.9,13.2c0.5,4.3,1.2,8.6,2.1,12.9
    c1.8,8.5,4.2,16.9,7.6,25.1c1.7,4.1,3.7,8.1,6.1,12c1.2,2,2.5,3.9,4,5.8c-1.6,1.2-3.3,2.3-5.1,3.1c-3.1,1.4-6.3,2.1-9.7,2.1l0,0
    c-0.3,0-0.5,0-0.8,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.1-0.8-0.2
    c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.5-0.1-0.8-0.3c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.8-0.4
    c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.1-0.5-0.3-0.8-0.4c-0.3-0.2-0.5-0.3-0.8-0.5c-0.1-0.1-0.3-0.2-0.4-0.2
    c-0.1-0.1-0.3-0.2-0.4-0.3c-0.3-0.2-0.5-0.4-0.8-0.5c-0.2-0.2-0.5-0.4-0.8-0.6c-0.5-0.4-1-0.8-1.5-1.2c-2-1.7-3.8-3.8-5.5-5.9
    c-1.7-2.2-3.4-4.5-4.9-7c-3-4.9-5.7-10.1-8.1-15.5c-1.9-4.4-3.7-8.9-5.4-13.4c4.6-7,9.1-14.1,13.2-21.5c4.3-7.7,8.3-15.6,11.6-24
    c1.6-4.2,3.1-8.5,4.2-13c1.1-4.5,1.9-9.2,1.9-14.2c0,0,0,0,0,0c0-4.1-0.3-8.3-1.1-12.5c-0.1-0.5-0.2-1.1-0.3-1.6
    c-0.1-0.5-0.2-1.1-0.4-1.6c-0.3-1.1-0.6-2.1-0.9-3.1c-0.7-2.1-1.6-4.2-2.7-6.2c-2.2-4-5.4-7.8-9.3-10.5c-0.1-0.1-0.2-0.2-0.4-0.3
    c-0.1-0.1-0.2-0.2-0.4-0.2c-0.3-0.2-0.5-0.3-0.8-0.5c-0.5-0.3-1.1-0.6-1.6-0.9c-1.1-0.5-2.2-1-3.3-1.4c-1.1-0.4-2.3-0.7-3.5-1
    c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.1c-0.3,0-0.6-0.1-1-0.1c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0
    c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0h0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.5,0
    c-0.3,0-0.6,0.1-1,0.1s-0.6,0.1-0.9,0.1c-0.3,0.1-0.6,0.1-0.9,0.2c-1.2,0.2-2.4,0.6-3.5,1c-1.1,0.4-2.2,0.9-3.3,1.4
    c-0.5,0.3-1.1,0.6-1.6,0.9c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.2-0.4,0.3c-4,2.7-7.2,6.4-9.3,10.5
    c-1.1,2-2,4.1-2.7,6.2c-0.4,1-0.7,2.1-0.9,3.1c-0.2,0.5-0.3,1.1-0.4,1.6s-0.2,1.1-0.3,1.6C0.3,31.9,0,36.1,0,40.2c0,0,0,0,0,0
    c0,6.5,0.7,12.8,1.5,19c0.8,6.2,1.9,12.3,3.2,18.4S7.4,89.7,9,95.7c1.4,5.2,3,10.4,4.7,15.5c-1.5,2.2-3.1,4.4-4.7,6.6
    c-1.2,1.7-2.5,3.4-3.8,5.1c-1.3,1.7-2.6,3.4-3.8,5c0,0-0.1,0.1-0.2,0.2l0,0c-0.8,1-1.3,2.3-1.3,3.6c0,3.2,2.6,5.8,5.8,5.8
    c1.9,0,3.5-0.9,4.6-2.2c0.1-0.1,0.2-0.2,0.2-0.2c1.4-1.8,2.7-3.5,4-5.3c1.3-1.8,2.6-3.5,3.9-5.3c0,0,0.1-0.1,0.1-0.2
    c0.9,2.2,1.8,4.4,2.8,6.6c2.6,5.8,5.5,11.4,8.9,16.9c1.7,2.7,3.6,5.4,5.6,8c1,1.3,2.1,2.6,3.3,3.8c0.6,0.6,1.2,1.2,1.8,1.8
    c0.6,0.6,1.2,1.2,1.9,1.8c0.7,0.6,1.3,1.1,2,1.7c0.4,0.3,0.7,0.5,1.1,0.8c0.4,0.3,0.7,0.5,1.1,0.8c0.2,0.1,0.4,0.3,0.6,0.4
    c0.2,0.1,0.4,0.2,0.6,0.4c0.4,0.2,0.8,0.5,1.2,0.7c0.4,0.2,0.8,0.4,1.2,0.7c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.6,0.3
    c0.4,0.2,0.9,0.4,1.3,0.6c0.4,0.2,0.9,0.3,1.4,0.5c0.4,0.2,0.9,0.3,1.4,0.4c0.2,0.1,0.5,0.1,0.7,0.2s0.5,0.1,0.7,0.2
    c1.9,0.5,3.9,0.7,5.9,0.7c0,0,0,0,0,0c2.5,0,5-0.3,7.5-0.8c2.5-0.5,4.9-1.4,7.1-2.4c3-1.4,5.8-3.2,8.3-5.2c2.5,2,5.2,3.9,8.3,5.2
    c2.3,1.1,4.7,1.9,7.1,2.4s5,0.8,7.5,0.8c0,0,0,0,0,0c2,0,4-0.2,5.9-0.7c0.2,0,0.5-0.1,0.7-0.2c0.2-0.1,0.5-0.1,0.7-0.2
    c0.5-0.1,0.9-0.3,1.4-0.4c0.4-0.2,0.9-0.3,1.3-0.5c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.2,0.6-0.3
    c0.4-0.2,0.8-0.4,1.2-0.7c0.4-0.2,0.8-0.5,1.2-0.7c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.1,0.4-0.3,0.6-0.4c0.4-0.3,0.7-0.5,1.1-0.8
    c0.4-0.3,0.7-0.5,1.1-0.8c0.7-0.5,1.3-1.1,2-1.7c0.7-0.6,1.3-1.2,1.9-1.8c0.6-0.6,1.2-1.2,1.8-1.8c1.1-1.2,2.2-2.5,3.3-3.8
    c2.1-2.6,3.9-5.3,5.6-8c3.4-5.5,6.3-11.1,8.9-16.9c1-2.2,1.9-4.4,2.8-6.6c0,0,0.1,0.1,0.1,0.2c1.3,1.8,2.6,3.5,3.9,5.3
    c1.3,1.8,2.6,3.5,4,5.3c0,0,0,0,0,0c1.1,1.5,2.8,2.4,4.7,2.4c3.2,0,5.8-2.6,5.8-5.8c0-1.4-0.5-2.6-1.3-3.6c0,0,0,0,0,0
    c-0.1-0.1-0.2-0.2-0.2-0.2c-1.3-1.6-2.6-3.3-3.8-5c-1.3-1.7-2.5-3.4-3.8-5.1c-1.6-2.2-3.1-4.4-4.7-6.6c1.7-5.1,3.3-10.3,4.7-15.5
    C164.6,89.7,166.1,83.7,167.4,77.6z M11.7,40.2L11.7,40.2c0-3.5,0.3-7,0.9-10.3c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.4,0.2-0.8,0.3-1.2
    c0.2-0.8,0.4-1.6,0.7-2.3c0.5-1.5,1.1-3,1.9-4.3c0.2-0.3,0.4-0.7,0.6-1c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.7-0.9
    c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.9-1.1,2-2,3.2-2.8c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.1
    c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.6-0.3,0.9-0.5c0.6-0.3,1.3-0.6,1.9-0.8c0.7-0.2,1.3-0.4,2-0.6c0.2,0,0.3-0.1,0.5-0.1
    c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0.1
    s0.3,0.1,0.5,0.1c0.2,0,0.3,0.1,0.5,0.1c0.7,0.1,1.3,0.3,2,0.6c0.7,0.2,1.3,0.5,1.9,0.8c0.3,0.2,0.6,0.3,0.9,0.5
    c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1c1.2,0.8,2.2,1.8,3.2,2.8c0.1,0.1,0.2,0.3,0.4,0.4
    c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.3,0.4,0.6,0.7,0.9c0.2,0.3,0.4,0.6,0.6,0.9s0.4,0.7,0.6,1c0.7,1.3,1.4,2.8,1.9,4.3
    c0.3,0.8,0.5,1.6,0.7,2.3c0.1,0.4,0.2,0.8,0.3,1.2s0.2,0.8,0.3,1.2c0.6,3.3,0.9,6.8,0.9,10.3c0,0,0,0,0,0c0,3.7-0.6,7.6-1.6,11.4
    s-2.2,7.8-3.7,11.6c-3,7.7-6.7,15.2-10.9,22.6c-2.4,4.4-5,8.7-7.7,12.9c-0.6-2-1.2-4-1.7-6c-1.6-5.8-3-11.6-4.2-17.4
    s-2.2-11.7-3-17.6C12.3,51.8,11.7,45.9,11.7,40.2z M71.7,109.8c-0.8-4-1.5-7.9-1.9-11.9c-0.5-4-0.8-8-0.8-11.9c0,0,0,0,0,0
    c0-2.5,0.4-4.9,1.1-7c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.2-0.5,0.4-0.7
    c0.1-0.2,0.3-0.5,0.4-0.7c0.6-0.9,1.2-1.7,2-2.4c1.5-1.5,3.5-2.6,5.7-3.4c1.1-0.4,2.3-0.7,3.5-1c0.6-0.1,1.2-0.2,1.8-0.3
    c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0c0.3,0,0.6,0,0.9,0.1
    c0.6,0.1,1.2,0.2,1.8,0.3c1.2,0.2,2.4,0.6,3.5,1c2.2,0.8,4.2,2,5.7,3.4c0.8,0.7,1.4,1.5,2,2.4c0.1,0.2,0.3,0.5,0.4,0.7
    c0.1,0.2,0.2,0.5,0.4,0.7c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.2,0.1,0.4c0.7,2.1,1.1,4.5,1.1,7
    c0,0,0,0,0,0c0,3.9-0.3,7.9-0.8,11.9c-0.5,4-1.1,8-1.9,11.9c-1.6,7.9-3.9,15.7-6.9,23c-1.5,3.6-3.3,7.2-5.3,10.4
    c-0.7,1.1-1.4,2.1-2.1,3.2c-0.7-1-1.4-2.1-2.1-3.2c-2-3.3-3.8-6.8-5.3-10.4C75.6,125.4,73.3,117.7,71.7,109.8z M160.4,40.2
    c0,5.7-0.6,11.6-1.4,17.4c-0.8,5.9-1.8,11.8-3,17.6s-2.6,11.7-4.2,17.4c-0.5,2-1.1,4-1.7,6c-2.7-4.3-5.3-8.6-7.7-12.9
    c-4.1-7.4-7.9-14.9-10.9-22.6c-1.5-3.8-2.8-7.7-3.7-11.6c-0.9-3.9-1.6-7.8-1.6-11.4c0,0,0,0,0,0c0-3.5,0.3-7,0.9-10.3
    c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.4,0.2-0.8,0.3-1.2c0.2-0.8,0.4-1.6,0.7-2.3c0.5-1.5,1.1-3,1.9-4.3c0.2-0.3,0.4-0.7,0.6-1
    c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.7-0.9c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.3,0.4-0.4c1-1.1,2-2,3.2-2.8
    c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.2,0.5-0.3c0.3-0.2,0.6-0.3,0.9-0.5c0.6-0.3,1.3-0.6,1.9-0.8
    c0.7-0.2,1.3-0.4,2-0.6c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
    c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.5,0.1s0.3,0.1,0.5,0.1c0.2,0,0.3,0.1,0.5,0.1c0.7,0.1,1.3,0.3,2,0.6
    c0.7,0.2,1.3,0.5,1.9,0.8c0.3,0.2,0.6,0.3,0.9,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1
    c1.2,0.8,2.2,1.8,3.2,2.8c0.1,0.1,0.2,0.3,0.4,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.3,0.4,0.6,0.7,0.9c0.2,0.3,0.4,0.6,0.6,0.9
    c0.2,0.3,0.4,0.7,0.6,1c0.7,1.3,1.4,2.8,1.9,4.3c0.3,0.8,0.5,1.6,0.7,2.3c0.1,0.4,0.2,0.8,0.3,1.2s0.2,0.8,0.3,1.2
    C160.1,33.2,160.4,36.7,160.4,40.2L160.4,40.2z"
      />
    </svg>
  );
};

export const SuccessToastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="27.999"
    viewBox="0 0 28 27.999"
    {...props}
  >
    <path
      id="Subtraction_23"
      data-name="Subtraction 23"
      d="M20197,9890a14,14,0,1,1,9.9-4.1A13.907,13.907,0,0,1,20197,9890Zm-6.014-14.966a.75.75,0,0,0-.529,1.281l4.3,4.307a.749.749,0,0,0,.527.218h.012a.768.768,0,0,0,.537-.233l7.725-8.177a.754.754,0,0,0-.031-1.06.744.744,0,0,0-.518-.206.731.731,0,0,0-.541.236l-7.2,7.613-3.754-3.759A.755.755,0,0,0,20190.986,9875.032Z"
      transform="translate(-20183 -9861.999)"
      fill="#fff"
    />
  </svg>
);

export const ErrorToastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="27.999"
    viewBox="0 0 28 27.999"
    {...props}
  >
    <path
      id="Subtraction_23"
      data-name="Subtraction 23"
      d="M20197,9890a14,14,0,1,1,9.9-4.1A13.907,13.907,0,0,1,20197,9890Zm0-9.875a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,20197,9880.123Zm0-11.246a.749.749,0,0,0-.75.746v8a.75.75,0,0,0,1.5,0v-8A.749.749,0,0,0,20197,9868.877Z"
      transform="translate(-20183 -9861.999)"
      fill="#fff"
    />
  </svg>
);

export const InfoToastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28.999"
    viewBox="0 0 29 28.999"
    {...props}
  >
    <path
      id="Subtraction_24"
      data-name="Subtraction 24"
      d="M20197,9890a14,14,0,0,1-.039-28h.037a14,14,0,0,1,0,28Zm-2-7.5a1,1,0,1,0,0,2h4a1,1,0,0,0,0-2h-1.127v-7.462a.82.82,0,0,0-.812-.764l-.064,0v-.03h-1.953a.949.949,0,0,0,.035,1.9h1.045v6.356Zm2-14.082a1.75,1.75,0,1,0,1.75,1.75A1.752,1.752,0,0,0,20197,9868.418Z"
      transform="translate(-20182.498 -9861.501)"
      fill="#fff"
      stroke="rgba(0,0,0,0)"
      strokeMiterlimit="10"
      strokeWidth="1"
    />
  </svg>
);
